export const destinationData = [
  {
    destination_id: "PASHUPATINATH-MUKTINATH-KAILASH-MANASAROVER_ID",
    title: "PASHUPATINATH-MUKTINATH-KAILASH-MANASAROVER",
    price: "£3000",
    description:
      "Pashupatinath–Muktinath–Kailash Manasarovar is a sacred pilgrimage circuit revered by Hindus and Buddhists, symbolizing the journey from life to liberation. It connects Nepal’s holiest Shiva temple (Pashupatinath), the liberation shrine (Muktinath), and the divine abode of Lord Shiva (Mount Kailash and Lake Manasarovar) in Tibet.",
    duration: "18 days",
    available: "N/A",
    included: "N/A",

    imageUrl: [
      {
        id: 5,
        url: "/assets/destination/pashupatinath/manasarover1.jpg",
      },
      {
        id: 6,
        url: "/assets/destination/pashupatinath/pashupatinath1.jpg",
      },
      {
        id: 90,
        url: "/assets/destination/pashupatinath/merge1.jpg",
      },
     
      {
        id: 1,
        url: "/assets/destination/pashupatinath/pashupatinath2.jpg",
      },
      {
        id: 2,
        url: "/assets/destination/pashupatinath/pashupatinath3.jpg",
      },
      {
        id: 3,
        url: "/assets/destination/pashupatinath/pashupatinath4.jpg",
      },
      {
        id: 4,
        url: "/assets/destination/pashupatinath/pashupatinath5.jpeg",
      },
    
      {
        id: 60,
        url: "/assets/destination/pashupatinath/manasarover2.jpg",
      },
      {
        id: 62,
        url: "/assets/destination/pashupatinath/manasarover3.jpg",
      },
      {
        id: 63,
        url: "/assets/destination/pashupatinath/muktinath1.png",
      },
      {
        id: 64,
        url: "/assets/destination/pashupatinath/muktinath2.jpeg",
      },
      {
        id: 65,
        url: "/assets/destination/pashupatinath/muktinath3.webp",
      },
    ],

    OverviewSubHeading:
      "Highlights of the PASHUPATINATH-MUKTINATH-KAILASH-MANASAROVER:",
    OverviewDescription1:
      "Pashupatinath–Muktinath–Kailash Manasarovar Yatra is a sacred pilgrimage connecting major Shiva temples and spiritual sites in Nepal and Tibet. It symbolizes the journey from life to liberation, drawing devotees seeking blessings, purification, and moksha.",

    OverViewDescription2:
      "The Pashupatinath–Muktinath–Kailash Manasarovar Yatra is a sacred journey that takes pilgrims to three of the most revered spiritual sites in Nepal and Tibet. The journey begins at Pashupatinath Temple in Kathmandu, dedicated to Lord Shiva, where people pray for peace and blessings. From there, they travel to Muktinath Temple in Mustang, a place believed to offer liberation and spiritual cleansing. The final destination is Kailash Manasarovar in Tibet, where Mount Kailash, considered the home of Lord Shiva, and the holy Lake Manasarovar offer pilgrims a path to spiritual fulfillment and salvation.",
    listofHighlights: [
      "Visit three of the most sacred pilgrimage sites: Pashupatinath, Muktinath, and Mount Kailash.",
      "Experience spiritual rituals including Puja, Havan, and holy bath at Lake Manasarovar and Muktinath.",
      "Witness the majestic view of Mount Kailash, considered the abode of Lord Shiva.",
      "Cross Dolma La Pass (5600m) – the highest and most sacred point of the Kailash Parikrama.",
      "Perform the sacred Parikrama (circumambulation) of Mount Kailash on foot.",
      "Explore UNESCO heritage sites in Kathmandu including Pashupatinath and Guhyeshwari Temple.",
      "Enjoy scenic drives through Himalayan landscapes and Tibetan plateaus.",
      "Fly to Jomsom and visit Muktinath Temple with its 108 water spouts and eternal flame.",
      "View stunning Himalayan peaks including Mt. Shishapangma and Gauri Shankar en route to Saga.",
      "Participate in the evening Arati at Pashupatinath Temple for a soul-stirring experience.",
      "Ride a cable car to Manakamana Temple and enjoy panoramic views (ticket not included).",
      "Relax and rejuvenate in Pokhara with sightseeing at Davis Falls and Gupteshwor Cave.",
      "Lake Manasarovar Parikrama by vehicle along its serene, sacred shoreline.",
      "Comfortable accommodation and full vegetarian meals throughout the journey.",
      "Support from experienced Nepali and Chinese guides, Sherpas, and a logistics team.",
    ],

    itinerary: [
      {
        day: "Day 01",
        activity: "Arrival in Kathmandu",
        activitydetails:
          "Arrival at Tribhuvan International Airport, Kathmandu. Meet and transfer to the hotel. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 02",
        activity: "Visa Processing & Kathmandu Sightseeing",
        activitydetails:
          "Morning: Sign Tibet visa form (biometric may be required at China Visa Centre). After visa process, enjoy a guided sightseeing tour of Pashupatinath Temple (UNESCO heritage and sacred Hindu site), Jal Narayan (Sleeping Vishnu), and Guhyeshwari Temple (associated with Goddess Parvati). Evening: Attend the spiritually uplifting Pashupatinath Arati Darshan. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 03",
        activity: "Leisure & Trip Preparation",
        activitydetails:
          "Reserved for visa processing. Optional private trips available (at own cost) to Chandragiri Hill (cable car ride and panoramic mountain views) or Doleshwar Mahadev Temple (believed to be the head of Kedarnath). Post-lunch: Final preparation for Kailash trip. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 04",
        activity: "Kathmandu – Rasuwagadhi (2500m) – 7 hrs / 152 km",
        activitydetails:
          "Scenic drive through rolling hills, terraced fields, and river valleys. Witness beautiful countryside landscapes. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 05",
        activity: "Rasuwagadhi – Kerung (2900m) – 26 km",
        activitydetails:
          "After breakfast, complete immigration and customs formalities on both Nepal and China sides. Drive to the small Tibetan town Kerung, located at the base of snow-capped mountains. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 06",
        activity: "Kerung – Saga (4500m) – 250 km",
        activitydetails:
          "Drive through high-altitude terrain, enjoying breathtaking views of Mt. Shishapangma (8021m), Gauri Shankar, and other majestic Himalayan peaks from Gurung La Pass (5050m). Overnight in Saga. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 07",
        activity: "Saga – Lake Manasarovar (4500m) – 385 km",
        activitydetails:
          "A spiritually significant day. En route, witness the first glimpse of the sacred Lake Manasarovar, believed to be created by Lord Brahma. From Horchu Pass, get the first divine view of Mount Kailash, the abode of Lord Shiva. Overnight stay at Chhu Gompa, situated on the serene shore of Lake Manasarovar. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 08",
        activity: "Manasarovar – Darchen (4560m) – 30 km",
        activitydetails:
          "A spiritually enriching day on the banks of Holy Lake Manasarovar, a place of purification and devotion. Perform Puja, Havan, Meditation, and Holy Bath rituals. In the afternoon, short drive to Darchen, the base for Kailash Parikrama. Overnight in hotel. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 09",
        activity: "Darchen – Tarboche – Diraphuk (4890m) – 18 km",
        activitydetails:
          "Parikrama (circuit) begins. Drive to Tarboche, the starting point of the Kailash trek, and sacred site of Yam Dwar (Gateway of the God of Death). Trek about 4–5 hours to Diraphuk, offering grand views of the north face of Mount Kailash. Overnight in guesthouse. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 10",
        activity: "Diraphuk – Dolma La – Zuthulphuk (4790m) – 22 km",
        activitydetails:
          "This is the most challenging and sacred part of the Yatra. Trek through Dolma La Pass (5600m), the highest point of the journey. Offer short prayers at the top and descend toward Gauri Kund, a sacred lake associated with Goddess Parvati. Reach Zuthulphuk, known for its caves and meditative legends. Overnight in guesthouse. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 11",
        activity: "Zuthulphuk – Darchen – Saga",
        activitydetails:
          "Trek 8 km to reach the pickup point where the bus awaits. Drive to Darchen, ending the Parikrama. After lunch, return journey via Lake Manasarovar and Horchu to Saga. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 12",
        activity: "Saga – Kerung",
        activitydetails:
          "Scenic return drive to Kerung, relaxing after the high-altitude trek. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 13",
        activity: "Kerung – Kathmandu",
        activitydetails:
          "Early morning drive to Friendship Bridge; clear Chinese and Nepal immigration. Drive back to Kathmandu, transfer to hotel. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 14",
        activity: "Leisure & Preparation Day in Kathmandu",
        activitydetails:
          "After a long journey from Tibet, take a day to rest and rejuvenate. Optional activities include visiting local temples, shopping for souvenirs, or relaxing at the hotel. This day also serves as a buffer for any unexpected delays in the return journey. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 15",
        activity: "Kathmandu – Pokhara",
        activitydetails:
          "After Kailash Yatra, begin the extension with a scenic drive to Pokhara, en route visit Manakamana Temple via cable car (ticket not included). Overnight in Pokhara. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 16",
        activity: "Pokhara – Jomsom – Muktinath",
        activitydetails:
          "Fly to Jomsom, then jeep ride to Muktinath Temple, a sacred pilgrimage site for both Hindus and Buddhists. Ample time for Puja, Darshan, and Holy Bath at the 108 spouts and natural flame. Drive back to Jomsom for overnight stay. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 17",
        activity: "Jomsom – Pokhara – Kathmandu",
        activitydetails:
          "Fly back to Pokhara, enjoy half-day sightseeing (Davis Falls, Gupteshwor Cave, etc.), then fly to Kathmandu. Transfer to hotel. Meal Plan: (B/L/D).",
      },
      {
        day: "Day 18",
        activity: "Departure",
        activitydetails:
          "After breakfast, departure transfer to airport. Meal Plan: (B).",
      },
    ],

    priceIncludes: [
      "Deluxe hotel in Kathmandu with full board meals",
      "Guided sightseeing tours and all surface transfers",
      "Tibet Visa, Entry Permits, and Kailash Parikrama Fee",
      "Best available accommodations during the entire trip, including 2 nights during Parikrama",
      "All pure vegetarian meals (Breakfast, Lunch, Dinner)",
      "Packed lunch during long drives and Parikrama",
      "Experienced Nepali and Chinese guides",
      "Supporting Sherpa team, luggage truck, and luxury bus",
      "Yaks and yak men during Parikrama for luggage transport",
      "First aid kit and oxygen cylinder for emergencies",
      "Lake Manasarovar Parikrama by private vehicle",
      "Kathmandu to Pokhara transfer by road",
      "1 night hotel accommodation in Pokhara and 1 night in Jomsom",
      "Domestic flights: Pokhara–Jomsom–Pokhara–Kathmandu",
      "Private jeep transportation for Jomsom–Muktinath–Jomsom route",
      "Experienced Nepali tour guide throughout the trip",
      "Souvenir gifts including a duffle bag, jacket, and day pack",
    ],

    priceExcludes: [
      "Tips and personal expenses (phone calls, drinks, mineral water, etc.)",
      "Additional services not mentioned in the program",
      "Rescue and emergency evacuation charges",
      "Extra hotel nights due to flight delays or cancellations",
      "International flights and travel insurance",
      "Manakamana Cable Car ticket",
    ],


    usefulInformation: [
      "Full Moon & Other Departure Dates for Kailash Yatra Itinerary:",
      "31st May 2026 – Jyeshtha Purnima",
      "29th June 2026 – Jeshtha Purnima",
      "29th July 2026 – Guru Purnima",
      "27th August 2026 – Raksha Bandan",
      "26th September 2026 – Bhadra Purnima",
    ],
  },

  {
    destination_id: "annapurna_trek",
    title: "Round Annapurna Circuit Trek",
    price: "N/A",
    description:
      "Embark on the classic Annapurna Circuit Trek, offering breathtaking views and diverse landscapes.",
    duration: "21 days",
    available: "N/A",
    included: "N/A",

    imageUrl: [
      {
        id: 6,
        url: "/assets/destination/AnnapurnaRound/annapurna5.jpeg",
      },
      {
        id: 1,
        url: "/assets/destination/annapurna.jpeg",
      },
      {
        id: 2,
        url: "/assets/destination/AnnapurnaRound/annapurna1.jpeg",
      },
      {
        id: 3,
        url: "/assets/destination/AnnapurnaRound/annapurna2.jpeg",
      },
      {
        id: 4,
        url: "/assets/destination/AnnapurnaRound/annapurna3.jpeg",
      },
      {
        id: 5,
        url: "/assets/destination/AnnapurnaRound/annapurna4.jpeg",
      },
      {
        id: 60,
        url: "/assets/destination/AnnapurnaRound/annapurna5.jpeg",
      },
    ],

    OverviewSubHeading: "Highlights of the Annapurna Sanctuary Trek:",
    OverviewDescription1:
      "Set out on a fantastic Annapurna trekking adventure that will take you all the way across the Annapurna Massif to the pinnacle of Thorong La Pass (5,416m). Without a doubt, the Annapurna circuit has become the world's most popular trekking route. Since 1977, this hiking trail has been open to foreign hikers. It offers breathtaking views of pastoral life and rice terraces cut into the vegetation, as well as an impressive snow-capped view of the Himalayas. The entire Annapurna mountain range is covered by this horseshoe-shaped route. It is a 300-kilometer walk through various terrains. This journey follows the old routes that were previously used as a commercial route between Nepal and Tibet, primarily for the exchange of salt.",

    OverViewDescription2:
      "Annapurna trekking is a well-known hiking route in the Annapurna region. The Annapurna circuit walk is a walk that circles Annapurna. Additional information about the following locations can be found near Annapurna: Tukuche Peak 6920m, Tilicho Peak 7134m, and others, and see various types of animals such as musk, leopards, jackals, mount thar, birds such as pheasant, birds with long tails, and others, as well as relax with a mixed culture such as Brahmin, Chhetri, Gurung, Magar Thakalis, and others. The Annapurna Thorung Pass is a Himalayan adventure in the Annapurna region that introduces us to the full and glorious spectrum of Nepal's landscapes by sneaking through a mountainous mosaic of picturesque landscapes with often wonderful beauties and shifting the wide-eyed walker from farms and lowland terraced forests to arid desert steppes, deep gorges and valleys, and the alpine tundra and giant Himalayan peaks to the north. On this trek, we can see the three powerful peaks of Manaslu (8163 m), Dhaulagiri (8 167 m) , Annapurna (8091 m), Dhaulagiri 8167m, Manaslu 8163m, Nilgiri 7041m, Fishtail / Machhapuchhare 6998m, Annapurna I 8091m, Annapurna II 7939m, Annapurna III7555m, Annapurna IV 7525m, Annapurna south 7219m, Hiunchuli 6441m, Lamjung Himal 6986.",
    listofHighlights: [
      " Cross the highest trekking pass in the world- Thorung La Pass.",
      "House of the Tibetan-Buddhists.",
      "One of the most popular trekking destinations in Nepal.",
      " Hiking on a much admired and beautiful hiking trail in the Annapurna region.",
      " The deepest gorge in the world, the valley of Kali Gandaki.",
      " Spectacular view of Dhaulagiri, Annapurna I, II, III, IV, Manaslu, Annapurna South, Nilgiri, Machhapuchhare, Hiunchuli, Lamjung Himal, Tukuche peak, Tilicho peak and so on.",
      " Transportation material likes of Tourist bus, private car/van, plane.",
      " Seasonal local fresh fruits like Apple which is most famous for.",
    ],

    itinerary: [
      {
        day: "Day 01",
        activity: "Arrival, Transfer to hotel",
        activitydetails:
          "Once you arrive in Kathmandu, a representative of the Go Nepal  will pick you up at the airport and take you to the hotel. In the afternoon you can rest or visit the office  for a local tea. In the evening, a welcome dinner will be organized by the Go Nepal. For dinner, enjoy the authentic Nepalese cuisine. Overnight in Kathmandu.",
      },
      {
        day: "Day 02",
        activity: "Kathmandu Sightseeing, Trekking Preparation",
        activitydetails:
          "Today, after breakfast, we begin our tour to some of the most historical and spiritual attractions of Kathmandu, also classified as UNESCO World Heritage. We visit historic Durbar Square, the sacred Hindu temple of Pashupatinath, the famous 'Monkey Temple' (Swayambhunath) and the Buddhist Sanctuary (Bouddhanath), which is also one of the largest stupas in the world. At the evening we got to meet each other in the hotel and discusses our trip for the next day. Overnight in Kathmandu.",
      },
      {
        day: "Day 03",
        activity:
          "We begin our journey in the hills by a winding road along the Trishuli River. On the way, we admire terraced farms and beautiful cabins. After arriving at an intersection in Mugling, we continue straight to Pokhara. In Dumre, we leave the previous road and head north towards Besisahar. A half-hour trip from Besisahar takes us to Khudi, the starting point of our hike. Alternatively, we can get off at Besisahar, then walk for an hour to get to Khudi by the wide road. Khudi gives us a first glimpse of the magnificent range of Manaslu. Overnight in Khudi.",
      },
      {
        day: "Day 04",
        activity: "Phakding - Namche Bazaar [3,440 m/11,283 ft]: 5-6 hrs",
      },
      {
        day: "Day 05",
        activity:
          "We leave Sirung for Jagat on a relatively easy path. We leave behind the village terraces and follow the path through the forests, ferns, and woodlands. On the forest trail, we spot a large variety of birds. We also cross several small towns and some temples along the way. We cross a suspension bridge in Sangu Khola in Mipra and then Syange in the Marshyangdi River. There is also a waterfall near the bridge. Now our road crosses the mighty Marshyangdi River and we cross another bridge before reaching Jagat. Overnight in Jagat.",
      },
      {
        day: "Day 06",
        activity:
          "After breakfast, we began our walk slowly. The path of Jagat descends towards the river, then crosses a leafy forest. Another climb leads to a sharp cliff facing the coast. On the way, we enter to Chyamje which offers us a magnificent scenery of the imposing mountain ranges of Annapurna. After crossing a suspension bridge, we climb abruptly towards the slippery and physically difficult road that leads to Sattale. Following a succession of paths strewn with stones, we descend to a grass bank that leads to Tal. When we move away from Tal, the road becomes bumpy and winding. Then we approach the wooded village of Karte. Along the waterfalls and cliffs, we finally reach Dharapani after crossing a suspension bridge. We will spend the night in Dharapani.",
      },
      {
        day: "Day 07",
        activity: "Fly back to Kathmandu",
        activitydetails:
          "Today, we cross some wooded ridges to go to Chame, which is the headquarters of the Manang district. Throughout the walk we can admire the impressive views of the Himalayas, including Lamjung Himal, Annapurna II and Annapurna IV (7,525 m / 24, 68 m). Today we also find small thermal springs where we can dive and relieve our sore muscles. Night in Chame.",
      },
      {
        day: "Day 08",
        activity: "Departure",
        activitydetails:
          "A narrow and steep path through a dense forest will lead us to the spectacular curved rock, which rises 1,500 meters from the river. This is probably the steepest part of the Marshyangdi Valley, so steep that the path is dug into the vertical rock. After passing this last rock, the valley opens on majestic views. And where the valley widens, there is Paungda Danda, a huge crag that rises more than 1500 meters above the trail. We walk for a while before reaching Lower Pisang where we will spend the night.",
      },
      {
        day: "Day 09",
        activity: "Pisang to Manang: 6 - 7 hours",
        activitydetails:
          "There are two routes to Manang, but we follow the path that takes us to Upper Pisang through Geru. This trail guarantees excellent views of the beautiful landscape and the majestic mountains, including Annapurna and Pisang. We begin to notice a contrast in the landscape and vegetation today onwards. The cold and dry climate also creates a much harder environment. Our brief visit to the Barge Monastery, the largest monastery in the entire Manang district, will be memorable. Night in Manang.",
      },

      {
        day: "Day 10",
        activity: "Manang: Acclimatization day",
        activitydetails:
          "To keep in shape on the trails that follow, today we are busy with a short hike to Bhojo Gumba or Gangapurna Lake. If we have enough energy, we can even go to the village of Vraga to visit the Himalayan Relief Association that will give us an idea of Acute Mountain Disease (AMS). Night in Manang.",
      },
      {
        day: "Day 11",
        activity: "Manang: 6 - 7 hours",
        activitydetails:
          "The last part of the hike is to the village of Bhojo Gumba. We are at the heart of the Manang district, and this is where the AMS comes into play. We will spend the night there.",
      },
    ],

    priceIncludes: [
      "All arrival and departure transfers in a private vehicle",
      "Hotels will be of tourist standard, and during trekking will be local tea house/guest house",
      "All meals (lunch and dinner) as described in the itinerary",
      "A private vehicle as per group size",
      "An English-speaking guide throughout the tour and trekking",
      "TIMS and permit",
      "For 2 guests, 1 porter will be provided",
      "Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    ],

    priceExcludes: [
      "Any kind of medical and personal insurance",
      "Any kind of personal nature items like bar and laundry bills",
      "Evacuation in case of emergency",
      "Domestic flights",
      "Tips to the guide and driver",
      "Entrance fees",
      "ANY ITEMS NOT MENTIONED ABOVE",
    ],
    usefulInformation: [
      "Discover the natural and cultural splendors of Nepal and Bhutan.",
      "Explore Nepal's UNESCO World Heritage Sites.",
      "Hike to Bhutan's enchanting Tiger's Nest Monastery.",
      "Discover cultural and historical landmarks such as dzongs and temples.",
      "Take in the breathtaking sunrise and sunset views from among the tall and mighty peaks.",
    ],
  },

  {
    destination_id: "everest_base_camp_trek",
    title: "Everest Base Camp Trek",
    price: "£1200",
    description:
      "A hike to Everest Base Camp is the adventure of a lifetime, a journey for those whose hopes and dreams float above the clouds. Trekking to Nepal's Everest Base Camp also allows us to embark on an epic journey that Sir Edmund Hillary and Tenzing Norgay embarked on in 1953.",
    duration: "16 days",
    available: "N/A",
    included: "N/A",
    imageUrl: [
      // {
      //   id: 1,
      //   url: "/assets/destination/helicoptor.jpeg",
      // },
      // {
      //   id: 2,
      //   url: "/assets/destination/everest1.jpeg",
      // },
      // {
      //   id: 3,
      //   url: "/assets/destination/everesthelicoptor.jpeg",
      // },
      {
        id: 4,
        url: "/assets/destination/everest/everest1.jpeg",
      },
      {
        id: 5,
        url: "/assets/destination/everest/everest2.jpg",
      },
      {
        id: 6,
        url: "/assets/destination/everest/everest3.webp",
      },
      {
        id: 7,
        url: "/assets/destination/everest/everest4.jpeg",
      },
      {
        id: 8,
        url: "/assets/destination/everest/everest5.jpeg",
      },
    ],
    facts: [
      "Everest Base camp is in the lap of world highest mountain Mount Everest (Sagarmatha in Nepali and Chomolungma in Tibetan 8848 m).",
      "Everest base camp is at an altitude of 5,364 m from the sea level.",
      "Everest Base camp trek usually starts from the Lukla airport. Which is the one of the most extreme adventurous airport in the world.",
      "Whether of base camp is always changing as per hour. Whether is not constant.",
      "Best season for trekking October to December and March to May.",
      "Every year more than 1 lakh trekkers trek to the Everest base camp.",
      "Everest base camp the trek takes 10 to 20 days depending on physical fitness of trekker and budget.",
      "Go Nepal operates any kind of trek to Everest like short, long, luxurious, Standard and Budget.",
    ],
    OverviewSubHeading: "Everest Base Camp Trek Some Quick Facts:",
    OverviewDescription1: `A hike to Everest Base Camp is the adventure of a lifetime, a journey for those whose hopes and dreams float above the clouds. Trekking to Nepal's Everest Base Camp also allows us to embark on an epic journey that Sir Edmund Hillary and Tenzing Norgay embarked on in 1953. The journey begins in ancient Kathmandu, where you can acclimate and explore the city at your leisure while waiting for your ascent. Your journey to Everest base camp at 5,364m up to the base of the world's highest mountain will take you across bridges crossing air vents, through hidden Buddhist monasteries, and deep into the heart of the world where sherpa hot and hard culture thrives. Nothing compares to the rush and sense of accomplishment that hikers feel when they see the power and grace of the mighty mountain up close.`,
    OverViewDescription2:
      "The 16-day Everest Base Camp Trek itinerary is intended for novice hikers in good health and fitness. The long distance between daily routes, the constant altitude gain, and the separate rest days ensure that we are properly acclimated to fully enjoy our trek to Everest Base Camp. However, if you want to take on a greater challenge offered by our agency, Go Nepal, and get off the beaten path, the Everest base camp through the Gokyo lakes in 18 days would be ideal. A 14-day trek is another option for experienced trekkers with limited time.",
    listofHighlights: [
      "The best season for trekking to Everest Base camp is October to December and March to May.",
      "During the base camp trekking, you can view Mount Everest (the highest mountain in the world) from its closest point.",
      "Mount Everest is also called Chomolungma and Sagarmatha.",
      "Everest base camp is inside the sagarmatha national park which is on the list of UNESCO world heritage site.",
      "Weather of the base camp keeps changing in the short amount of time.",
      "Namche bazaar is also called the capital of Sherpa, who are known as the 'the king of the himalayas'.",
      "Evidently, every year more than 1 lakh trekkers trek to the Everest base camp.",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival in Kathmandu (1,350m/4,428ft)",
        activitydetails:
          "Today you’ll arrive at Kathmandu international airport. Our agent will pick you and take you to the respective hotel where you refresh and rest. All the necessary information on tour provided in hotel. In the evening a welcome dinner will be hosted by Go Nepal. Overnight stay at hotel.",
      },
      {
        day: "Day 2",
        activity: "Kathmandu: Sightseeing and trek Preparation",
        activitydetails:
          "We visit Durbar Square, Pashupatinath Temple, Swayambhunath Stupa, and Bouddhanath Stupa, all of which are World Heritage Sites. In the evening, we introduce ourselves to our fellow participants and discuss our trip to the Everest Base Camp. Overnight in Kathmandu.",
      },
      {
        day: "Day 3",
        activity:
          "Fly to Lukla, trek to Phakding (2,651m/8,700ft): 40 minutes flight; 8km, 3 - 4 hours trek",
      },
      {
        day: "Day 4",
        activity:
          "Phakding to Namche Bazaar (3,438m/11,280 ft): 11km, 5 - 6 hours",
      },
      {
        day: "Day 5",
        activity: "Acclimatization Day - Namche Bazaar: (3,440m/11,284ft)",
      },
      {
        day: "Day 6",
        activity:
          "Namche Bazaar to Tengboche (3,870m/12,694ft): 10km, 5- 6 hours",
      },
      {
        day: "Day 7",
        activity:
          "Tengboche to Dingboche (4,360 m/14,300 ft): 9km, 5 - 6 hours",
      },
      {
        day: "Day 8",
        activity: "Dingboche: Acclimatization",
      },
      {
        day: "Day 9",
        activity: "Dingboche to Duglha (4,600 m/15,090 ft): 4km, 3 - 4 hours",
      },
      {
        day: "Day 10",
        activity: "Duglha to Lobuche (4,940 m/16,207 ft): 4km, 2 - 4 hours",
      },
      {
        day: "Day 11",
        activity:
          "Lobuche to Gorak Shep (5,170 m/16,961ft), visit Everest Base Camp (5,364 m/17,594 ft): 13km, 6-7 hours",
      },
      {
        day: "Day 12",
        activity:
          "Gorak Shep to Kala Patthar (5,545m/18,192ft) to Pherice (4,288m/14,070ft): 16km, 7-8 hours",
      },
      {
        day: "Day 13",
        activity:
          "Pheriche to Namche Bazaar (3,440m/11,280 ft): 20km, 6 - 7 hours",
      },
      {
        day: "Day 14",
        activity: "Namche Bazaar to Lukla (2,860m/9,186ft): 19km, 6 - 7 hours",
      },
      {
        day: "Day 15",
        activity: "Fly to Kathmandu",
      },
      {
        day: "Day 16",
        activity: "Final departure",
      },
    ],
    priceIncludes: [
      "Airport pickups and drops in a private vehicle",
      "3-star hotel accommodation in Kathmandu with breakfast",
      "Teahouse accommodation during the trek",
      "All meals during the trek (15 breakfast, 12 Lunch, 12 Dinner)",
      "Welcome and farewell dinners",
      "All ground transportation on a comfortable private vehicle as per the itinerary",
      "Domestic flights (Kathmandu- Lukla -Kathmandu)",
      "An experienced, English-speaking and government-licensed trek leader and assistant trek leader (4 trekkers: 1 assistant guide)",
      "Porter service (2 trekkers: 1 porter)",
      "Staff costs including their salary, insurance, equipment, domestic airfare, food and accommodation",
      "Down jacket and sleeping bag  (to be returned after trip completion)",
      "Trekking bag/duffel bag, t-shirt and trekking map are yours to take",
      "All necessary paperwork and trekking permits (National Park Permit, TIMS)",
      "Medical kit (carried by your trek leader)",
      "All government and local taxes",
    ],
    priceExcludes: [
      "Nepal visa fee (bring small denomination cash USD and two passport photographs )",
      "International Airfare",
      "Entrance fee during the sightseeing in Kathmandu",
      "Travel & Health Insurance – Emergency Helicopter Rescue Insurance (Most recommended)",
      "Lunch & dinner in Kathmandu.",
      "Any alcoholic drinks, cold drinks, boiled & mineral water, beverages etc during the trek.",
      "Tipping for related staffs",
      "Hot shower, battery charges (available in trek with extra cost or free in some lodges).",
      "Extra night accommodation in Kathmandu because of early arrival, late departure, and early return from the mountain(due to any reason) than the scheduled itinerary",
      "Any other cost, which is not mentioned in cost includes items as above.",
      "Tips for Guide, Porter and Driver.",
    ],
    usefulInformation: [
      "The best season for trekking to Everest Base camp is October to December and March to May.",
      "During the base camp trekking, you can view Mount Everest (the highest mountain in the world) from its closest point.",
      "Mount Everest is also called Chomolungma and Sagarmatha.",
      "Everest base camp is inside the sagarmatha national park which is on the list of UNESCO world heritage site.",
      "Weather of the base camp keeps changing in the short amount of time.",
      "Namche bazaar is also called the capital of Sherpa, who area known as the 'the king of the himalayas'.",
      "Evidently, every year more than 1 lakh trekkers trek to the Everest base camp.",
    ],
  },

  {
    destination_id: "annapurna_base_camp_trek",
    title: "Annapurna Base Camp Trek",
    price: "£700",
    description:
      "Annapurna Base Camp (ABC) Trek is one of the most popular treks in Nepal. It is a fairly easy and shorter walk than other high-altitude walks in Nepal. This hike incorporates diverse terrains, culture and wildlife. Along with the most spectacular and close view of the range of Annapurna, Machhapuchhre, Hiunchuli and Dhaulagiri.",
    duration: "11 days",
    available: "Trekking & Hiking",
    included: "N/A",
    imageUrl: [
      {
        id: 2,
        url: "/assets/destination/annapurnabasecamp/annapurna1.jpeg",
        alt: "Annapurna Base Camp",
      },
      {
        id: 3,
        url: "/assets/destination/annapurnabasecamp/annapurna2.webp",
        alt: "Annapurna Base Camp",
      },
      {
        id: 4,
        url: "/assets/destination/annapurnabasecamp/annapurna3.jpeg",
        alt: "Annapurna Base Camp",
      },
      {
        id: 5,
        url: "/assets/destination/annapurnabasecamp/annapurna4.jpeg",
        alt: "Annapurna Base Camp",
      },
      {
        id: 6,
        url: "/assets/destination/annapurnabasecamp/annapurna5.jpeg",
        alt: "Annapurna Base Camp",
      },
    ],
    OverviewSubHeading: "Annapurna Base Camp Trek Overview:",
    OverviewDescription1: `Annapurna Base Camp (ABC) Trek is one of the most popular treks in Nepal. It is a fairly easy and shorter walk than other high-altitude walks in Nepal. This hike incorporates diverse terrains, culture and wildlife. Along with the most spectacular and close view of the range of Annapurna, Machhapuchhre, Hiunchuli and Dhaulagiri. The Annapurna Base Camp shows you all the mountain ranges that are beautiful, colossal and covered with snow against the blue sky. Here, the air is pure and a hiker thrives in front of this impressive mountain range. The mountains are inextricably linked to you in the base camp and create such a unique environment. Only panoramic and scenic views of Annapurna II, III, IV, Annapurna South, Tent Peak, Hiunchuli, Gangapurna, and Annapurna South are visible. Its beauty is indescribable; they beckon your attention, and all you can do is take photos with your camera as much as you want and as far as you can get to the base camp's corners.`,
    OverViewDescription2:
      "It blooms with many beautiful flowers in the spring, including Nepal's national flower, the rhododendron. During the walk, you will be accompanied by orchids, the Machhapuchhre massif, and the Kali Gandaki's deepest gorge. You will notice high waterfalls along the way and will stop at the Ghandruk Museum to learn more about people of different ethnicities, particularly the Gurung community. The Annapurna base camp, located at 4130 meters above sea level, is unique and incredibly beautiful, surrounded by the majestic peaks of Annapurna South (7219 meters), Annapurna I (8091 meters), Hiunchuli (6441 meters), and Machapuchhre (6993 m). The Annapurna Base Camp Trek can take anywhere from 7 to 12 days to complete, depending on your itinerary and the length of your walking days. The itinerary presented here is designed for globetrotters who want to reach the spectacular mountain base camp in 11 days.",
    listofHighlights: [
      "From Pokhara, the Annapurna range whets your appetite for mountain views.",
      "The Annapurna Base Camp is a small collection of lodges located directly across from the Annapurna glacier.",
      "Annapurna I (8,091 m) has a lethal allure for mountaineers. Among the eight-thousanders, it has the highest fatality rate.",
      "The best seasons to trek to Annapurna Base Camp are from mid-September to November (autumn) and March to May (spring).",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival in Kathmandu (1,300m/4,264ft)",
        activitydetails:
          "Once you arrive in Kathmandu, a representative from the Go Nepal will pick you up at the airport and drop you to the hotel. In the afternoon, you can rest, refresh yourself and have a good tea or coffee. In the evening, a welcome dinner will be held by the Go Nepal. For dinner, you can enjoy authentic Nepalese cuisine. Overnight in Kathmandu.",
      },
      {
        day: "Day 2",
        activity:
          "Fly to Pokhara (827m/2,700ft), trek to Ghandruk (1940m/6360 ft): 30 minutes flight, 5 - 6 hours trek",
        activitydetails:
          "We take an early morning scheduled flight to Pokhara, the beautiful city of the lake, and where we can enjoy a breathtaking view of the Himalayas from the right side of our plane. After landing at the Pokhara airport, we will drive to Naya Pul (1 hour and 20 minutes) and begin the trek. From Birethanti, we walk to Ghandruk, a beautiful village inhabited mainly by the Gurung community. Weather permitting, we also visit the Gurung Museum today. Night in Ghandruk.",
      },
      {
        day: "Day 3",
        activity: "Ghandruk to Chhomrong (2170m/7120ft): 5 - 6 hours",
        activitydetails:
          "At this point, we will stroll for about an hour to Kimrungdanda. On the way, we can enjoy excellent views of Annapurna South, Hiunchuli, Fishtail Mountain (Machhapuchhre) and Ganggapurna. A strong descent takes us to Kimrong Khola. After another strong stroll from Kimrong Khola to Chere Danda, we descend for a while and then it is a smooth walk to Chhomrong. Chhomrong is a beautiful village located in the lap of the gigantic Annapurna. We will spend the night in Chhomrong.",
      },
      {
        day: "Day 4",
        activity: "Chhomrong to Bamboo (2310m/7578ft): 4 - 5 hours",
        activitydetails:
          "We descend by 2500 stone steps and cross the bridge over Chhomrong Khola. From there, it's a difficult climb for Sinuwa. Then we cross a beautiful forest to Kuldihar, then we descend easily to bamboo. Bamboo Night on this day.",
      },
      {
        day: "Day 5",
        activity: "Bamboo to Deurali (3230m/10,595ft): 3 - 4 hours",
        activitydetails:
          "We crossed a humid and cold bamboo forest, then climbed regularly with some steep slopes. Only after arriving at the Himalaya region, the forest opens up and we are again exposed to the sun with an impressive view of the glacier river. It is a steep climb through a much drier forest before reaching the Hinku cave. From there, we can see the trail descending closer to the river before returning to Deurali, the most picturesque part of the day. The vegetation is sparser, allowing magical views of the valley, the river below and steep cliffs at the top of the rocks covered with bands of waterfalls. Night in Deurali.",
      },
      {
        day: "Day 6",
        activity:
          "Deurali to Annapurna Base Camp (4,130m/13,545ft) via Machhapuchhre Base Camp (3700m/12135ft): 5- 6 hours",
        activitydetails:
          "Climb gently up the riverbed and then up a steep path to the side of the mountain. The walk from Bagar to Machhapuchhre Base Camp is hard. From the base camp of Machhapuchhre, we have excellent views of the majestic Machhapuchhre and Mt. Hiunchuli, Annapurna South, Annapurna I, Annapurna III, Gandharvachuli and Gangapurna are certainly gratifying experiences. The vegetation disappears on our way to ABC and the road widens when we enter the Annapurna Sanctuary. From there, we have a sensational view of the almost vertical south face of the Annapurna that rises above us. The sanctuary has a dynamic view without anything preventing the 360 degree panorama. From the base camp, we once again can enjoy a fascinating view of Machhapuchhre, Annapurna South, Annapurna I, Hiunchuli and other peaks. Overnight at Annapurna base camp.",
      },
      {
        day: "Day 7",
        activity: "Annapurna Base Camp to Bamboo: 7 – 8 hours",
        activitydetails:
          "From the Annapurna base camp, we retrace our steps towards the bamboo. Today's descent is downhill, so it should not be very difficult. In addition, we will always have the company of this extraordinary landscape to cheer us up. Bamboo Night should be fun.",
      },
      {
        day: "Day 8",
        activity: "Bamboo to Jhinu Danda (1760m/5770 ft): 5 - 6 hours",
        activitydetails:
          "From Bamboo the journey is slightly uphill to Kuldighar, followed by a descent to Chhomrong Khola. Then we climb the stone steps that lead to Chhomrong. The path then descends to Jhinu Danda, where we will rest at night. Today we will have the opportunity to enjoy the hot springs, just 15-20 minutes walk from Jhinu Danda to soothe our aching body. We will spend the night in Jhinu Danda.",
      },
      {
        day: "Day 9",
        activity:
          "Trek to Naya Pul then drive to Pokhara: 6 hours trek, 1 hour drive",
        activitydetails:
          "From Jhinu Danda to Naya Pul, we can enjoy the beautiful mountainous landscape of western Nepal. We can have lunch on the way to Naya Pul. Our walk will end at Naya Pul, where we will board Pokhara in our vehicle. Overnight in Pokhara.",
      },
      {
        day: "Day 10",
        activity: "Fly to Kathmandu",
        activitydetails:
          "We fly to Kathmandu in the afternoon. Once we land in Kathmandu, a representative will transfer you to the hotel. You can spend your day quietly or make last-minute purchases or explore the Kathmandu area upon time permits. To celebrate the success of our trip, we will have a farewell dinner at night. Overnight in Kathmandu.",
      },
      {
        day: "Day 11",
        activity: "Final Departure",
        activitydetails:
          "Our trip to Nepal ends today. A representative of the Go Nepal will drop you at the airport approximately 3 hours before your scheduled flight. On the way back, you have enough time to reflect on your journey back to Annapurna Basecamp and plan your next adventure in the wonderful country of Nepal.",
      },
    ],
    priceIncludes: [
      "Airport pickups and drops in a private vehicle",
      "3-star hotel accommodation in Kathmandu with breakfast",
      "3-star hotel accommodation in Pokhara with breakfast",
      "Entrance fee during the sightseeing in Kathmandu.",
      "Flight Ticket as per Itinerary.",
      "All meals during the trek",
      "Welcome and farewell dinners.",
      "All ground transportation on a comfortable private vehicle as per the itinerary",
      "An experienced, English-speaking and government-licensed trek leader and assistant trek leader (4 trekkers: 1 assistant guide)",
      "Porter service (2 trekkers: 1 porter)",
      "Staff costs including their salary, insurance, equipment, domestic airfare, food and accommodation.",
      "Down jacket and sleeping bag  (to be returned after trip completion)",
      "All necessary paperwork and trekking permits (National Park Permit, TIMS)",
      "Medical kit (carried by your trek leader)",
      "All government and local taxes",
    ],
    priceExcludes: [
      "Nepal visa fee (bring small denomination cash USD and two passport photographs ).",
      "International Airfare",
      "Travel & Health Insurance – Emergency Helicopter Rescue Insurance (Most recommended)",
      "Lunch & dinner in Kathmandu.",
      "Any alcoholic drinks, cold drinks, boiled & mineral water, beverages etc during the trek.",
      "Tipping for related staffs",
      "Hot shower, battery charges (available in trek with extra cost or free in some lodges).",
      "Extra night accommodation in Kathmandu and Pokhara because of early arrival, late departure, and early return from the mountain(due to any reason) than the scheduled itinerary",
      "Any other cost, which is not mentioned in cost includes items as above.",
      "Tips for Guide, Porter and Driver.",
    ],
    usefulInformation: [
      "From Pokhara, the Annapurna range whets your appetite for mountain views.",
      "The Annapurna Base Camp is a small collection of lodges located directly across from the Annapurna glacier.",
      "Annapurna I (8,091 m) has a lethal allure for mountaineers. Among the eight-thousanders, it has the highest fatality rate.",
      "The best seasons to trek to Annapurna Base Camp are from mid-September to November (autumn) and March to May (spring).",
    ],
  },

  {
    destination_id: "kathmandu_heritage_tour",

    title: "Kathmandu Heritage Tour",
    price: "£45",
    description:
      "Kathmandu is known as the 'City of Temples,' and it has five UNESCO World Heritage Sites. The Kathmandu Valley's cultural heritage is represented by seven groups of monuments and buildings that showcase the full range of historic and artistic achievements for which the Kathmandu Valley is world-famous.",

    duration: "1 day",
    available: "Day Tours",
    included: "N/A",
    imageUrl: [
      {
        id: 1,
        url: "/assets/destination/heritage.jpeg",
      },

      {
        id: 4,
        url: "/assets/destination/kathmandu/kathmandu3.jpeg",
      },
      {
        id: 5,
        url: "/assets/destination/kathmandu/kathmandu4.jpeg",
      },
      {
        id: 6,
        url: "/assets/destination/kathmandu/kathmandu5.jpeg",
      },
      {
        id: 7,
        url: "/assets/destination/kathmandu/kathmandu6.jpeg",
      },
    ],

    OverviewSubHeading: "Highlights of the Kathmandu Heritage Tour:",
    OverviewDescription1:
      "Kathmandu is known as the City of Temples, and it has five UNESCO World Heritage Sites. The Kathmandu Valleys cultural heritage is represented by seven groups of monuments and buildings that showcase the full range of historic and artistic achievements for which the Kathmandu Valley is world famous. The Durbar Squares of Hanuman Dhoka (Kathmandu), Patan, and Bhaktapur are among the seven, as are the Buddhist stupas of Swayambhu and Bauddhanath, and the Hindu temples of Pashupati and Changu Narayan.You will mostly enjoy Kathmandu because of the beautiful mountain scenery you will be able to see. Whether you're riding a rickshaw through the traffic-choked alleyways of the old town, admiring the medieval temples, or dodging trekking touts in the backpacker district of Thamel, Kathmandu can be intoxicating, amazing, and exhausting. ",
    OverViewDescription2: `The world heritage tour in Kathmandu gives us a close-up look at Nepal. Nepal is not only a showcase of the Nepalese people's rich culture, but it is also a nation of architectural marvels and heritage sites. This tour takes you to four temples: Kathmandu Durbar Square, Pashupatinath, Bauddhanath, and Swayambhunath, all of which are religious and culturally significant to Nepalese people.
      The Kathmandu Durbar Square houses the palaces of the city's rulers, the Malla and Shah Kings. In addition to these palaces, the square is surrounded by quadrangles that reveal courtyards and temples. It is one of three Durbar Squares in Nepal's Kathmandu Valley that are UNESCO World Heritage Sites.
      Swayambhu, a UNESCO World Heritage Site, dates back to antiquity. A 5th century stone inscription is the earliest written record of the Great Stupa of Swayambhu. The stupa, which has been honored by kings, monks, and pilgrims alike, has been restored and repaired on numerous occasions.
      The precise date of construction of Pashupatinath is unknown. Despite this, Pashupatinath is considered Kathmandu's oldest Hindu temple. Because of the large monkey population that lives in the area, it is popularly known as the Monkey Temple among foreigners. The story of the Bouddha Stupa is significant and incredibly inspiring. The Boudhanath Buddhist stupa dominates the skyline. The ancient Stupa is one of the world's largest. Due to the influx of large populations of Tibetan refugees, over 50 Tibetan Gompas (Monasteries) have been built around Boudhanath. Boudhanath was designated a UNESCO World Heritage Site in 1979. It is, along with Swayambhunath, one of the most popular tourist destinations in the Kathmandu area.`,
    listofHighlights: [
      "Discover the city of Kathmandu and its heritage sites.",
      "Panoramic and close-up views of the Annapurna massif, explore the city of Pokhara on the shores of Lake.",
      "Unimpeded sunrise and sunset view from Poon Hill, picturesque villages.",
      "Experiencing the lifestyle and culture of Gurung and Magar people, who are very famous for Gorkha arm.",
      "Walk the narrow, cobbled path in the valley and the remote villages.",
      "Visit the old monastery, ancient tradition of the Gurung museum and waterfalls.",
      "Panoramic mountain flight to and from Pokhara.",
      "Walk through the dense forest of Rhododendron which is even more beautiful in the spring.",
    ],

    itinerary: [
      {
        day: "1st place",
        activity: "Pasupatinath Temple",
        activitydetails:
          "Pashupatinath Temple is Kathmandu's oldest Hindu temple and a UNESCO World Heritage Site.",
      },
      {
        day: "2nd Place",
        activity: "Bouddhanath Stupa",
        activitydetails:
          "Boudhanath Stupa is one of the world's largest stupas and a UNESCO World Heritage Site.",
      },
      {
        day: "3rd Place",
        activity: "Patan Durbar Square",
        activitydetails:
          "Patan Durbar Square showcases the rich architectural heritage of the Malla dynasty.",
      },
      {
        day: "4th Place",
        activity: "Swayambhunath Stupa",
        activitydetails:
          "Swayambhunath Stupa, also known as the Monkey Temple, is an ancient stupa with panoramic views of Kathmandu valley.",
      },
    ],
    priceIncludes: [
      "Private Car as per the Itinerary",
      "English speaking tour guide",
      "Monument entrance fee",
      "1 bottle of water for each person",
    ],
    priceExcludes: [
      "Personal Nature Expenses",
      "Other expenses not mentioned in the 'Cost Includes' section",
    ],
    usefulInformation: [
      "Tour starts at 9 am",
      "Ends between 3-5 pm",
      "Trip Duration: 6-8 hours",
      "Departure from: Go Nepal Travel, Tours & Trekking (Thamel, Kathmandu, Nepal)",
      "Minimum 2 Pax in a group",
    ],
  },

  {
    destination_id: "everest_basecamp_trek_via_gokyo_lake_and_cho_la_pass",
    title: "Everest Basecamp Trek Via Gokyo Lake And Cho La Pass",
    price: "£1400",
    description:
      "If connecting with nature as well as conquering altitude is important to you, the Everest Basecamp Trekking via Gokyo Lake and Cho La Pass is for you. This is one of the best options for hikers seeking the best trekking experience in Everest Base Camp. The Everest base trek through the Gokyo Lakes and Cho La Pass, recognized by the series of beautiful turquoise lakes of the Gokyo Valley and the famous Cho La Pass, takes us through the Khumbu region in the company of majestic mountains, friendly Sherpas, colorful monasteries of Namche Bazaar, the Sagarmatha National Park, and, of course, the base of the mighty Everest. It's simply unbeatable and makes this detour (west of Everest) more picturesque, serene, challenging and worthy of your time and your efforts.",
    duration: "18 days",
    available: "Trekking & Hiking",
    included: "minimum 2 person",
    imageUrl: [
      {
        id: 1,
        url: "/assets/destination/everestgokyo/everest1.jpeg",
        alt: "everest gokyo",
      },
      {
        id: 2,
        url: "/assets/destination/everestgokyo/everest2.jpeg",
        alt: "everest gokyo",
      },
      {
        id: 3,
        url: "/assets/destination/everestgokyo/everest3.jpeg",
        alt: "everest gokyo",
      },
      {
        id: 4,
        url: "/assets/destination/everestgokyo/everest4.jpeg",
        alt: "everest gokyo",
      },
      {
        id: 5,
        url: "/assets/destination/everestgokyo/everest5.jpeg",
        alt: "everest gokyo",
      },
      {
        id: 6,
        url: "/assets/destination/everestgokyo/everest6.jpeg",
        alt: "everest gokyo",
      },
    ],
    OverviewSubHeading:
      "Everest Basecamp Trek Via Gokyo Lake And Cho La Pass Overview",
    OverviewDescription1: `If connecting with nature as well as conquering altitude is important to you, the Everest Basecamp Trekking via Gokyo Lake and Cho La Pass is for you. This is one of the best options for hikers seeking the best trekking experience in Everest Base Camp. The Everest base trek through the Gokyo Lakes and Cho La Pass, recognized by the series of beautiful turquoise lakes of the Gokyo Valley and the famous Cho La Pass, takes us through the Khumbu region in the company of majestic mountains, friendly Sherpas, colorful monasteries of Namche Bazaar, the Sagarmatha National Park, and, of course, the base of the mighty Everest. It's simply unbeatable and makes this detour (west of Everest) more picturesque, serene, challenging and worthy of your time and your efforts.`,
    OverviewDescription2: `The walk to the base of the world's highest mountain maps provides breathtaking views of famous landmarks like Gokyo RI and Kala Patthar. The walk also provides us with excellent views of the Khumbu Icefall. Stroll through Gokyo Lakes to Everest Base Camp. In short, it will be an unforgettable experience with breathtaking views of Mt. Cho Oyu Monastery, Everest, Lhotse, Makalu, Nuptse, Amadablam, Pumori, and Tengboche: Nepal's largest monastery. The Gokyo Lakes Trek to Everest Base Camp is ideal for hikers who want to take on more difficult challenges that some people do not dare to attempt.`,

    listofHighlights: [
      "The challenging altitude: Mt. Everest Base Camp (5,364m), Kala Patthar (5,550m), and Chola Pass (5,420m).",
      "Sacred Gokyo Lakes (Longponga Tsho, Taujung Tsho, Gokyo Tsho, Thonak Tsho, Ngozumba Tsho and so on.",
      "A series of six emerald-green, freshwater lakes on the moraine beside Ngozumpa Glacier.",
      "Sunrise view over jaw-dropping mountain vista (including the highest Mt. Everest) from Kala Patthar",
      "Opportunity to view 4 of the 10 highest peaks in the world.",
      "The Khumbu Glacier (world’s highest glacier) and Ngozumpa Glacier (the longest glacier the Himalayas)",
      "The company of majestic mountains, the friendly Sherpas, the colourful monasteries of the Namche Bazaar,",
      "The Sagarmatha National Park and, of course, even the base of the mighty Everest.",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival in Kathmandu (1,350m/4,428ft)",
        activitydetails:
          "Upon arrival at Tribhuwan International Airport (TIA) in Kathmandu, you will be greeted by a representative of Go Nepal who will drive you to the hotel. After check-in, you can rest and refresh yourself for the time being. In the evening, welcome dinner in a traditional Nepalese restaurant, where you can enjoy authentic Nepalese cuisine. Overnight in Kathmandu.",
      },
      {
        day: "Day 2",
        activity: "Kathmandu: Sightseeing and trek Preparation",
        activitydetails:
          "Today, after breakfast, we begin our tour to some of the most historical and spiritual attractions of Kathmandu, which are also classified as UNESCO World Heritage. We visit the historic Durbar Square, the sacred Hindu temple of Pashupatinath, the famous Monkey Temple (Swayambhunath) and the Buddhist Sanctuary (Bouddhanath), which is also one of the largest stupas in the world. At the evening, we will introduce you to the other participants and discuss our trip to the Everest Basecamp for the next day. Overnight in Kathmandu.",
      },
      {
        day: "Day 3",
        activity: "Fly to Lukla, trek to Phakding (2,651m/8,700ft)",
        activitydetails:
          "During the 40-minute flight from Kathmandu to Lukla (9186 feet), we take an advantage of one of the most beautiful air routes in the world, which culminates on a hill surrounded by high peaks. In Lukla, the starting point of our hike, we meet the other crew members and begin to prepare our belongings and make arrangements with them. From Lukla, we start trekking. After an hour of progressive descent, we will be in a village Cheplung from where we can see the Mountain Khumbila (18900 feet), a sacred mountain that has never been climbed. From Cheplung, we descend gradually to Phakding and spend the night over there.",
      },
      {
        day: "Day 4",
        activity: "Phakding to Namche Bazaar (3,438m/11,280 ft)",
        activitydetails:
          "Walking through a beautiful pine forest, we follow the path towards the north of the Benkar Valley. Then we cross the Dudh Koshi River and continue to Chumoa towards Monjo, the entrance to Everest National Park. After crossing a suspension bridge, we crossed the village of Jorsale and lead through the rivers Dudh Koshi and Bhote Koshi. A steep climb takes us to the heart of Sherpa Village: Namche Bazaar. An hour interspace to Namche Bazaar, weather permitting, we can see the view of the Mt. Everest and Mt. Lhotse. We will spend the night at Namche Bazaar.",
      },
      {
        day: "Day 5",
        activity: "Acclimatization Day - Namche Bazaar",
        activitydetails:
          "There are many things to do in Namche Bazaar where we can spend a day acclimatizing here. Namche Bazaar is the main center of the Khumbu area and includes government offices, ATMs, cybercafés, local shops, restaurants and a colorful market. Our guides can take us to discover the true charm of the Namche Bazaar. Hiking at Sagarmatha National Park rewards with a view of the sunrise as well as view of Mount Everest, Lhotse, Nuptse, Ama Dablam, Thamserku, and Kongde etc. If we are interested in a day hike, we will walk to the village of Khumjung (12401 feet), a beautiful village with a Sherpa colony. While exploring Namche Bazar, we observe the traditional Sherpa life, Khumjung Hillary School, and enjoy the flora and fauna found at this altitude. We will spend the night at Namche Bazaar.",
      },
      {
        day: "Day 6",
        activity: "Namche Bazaar to Phortse Thanga (3,680m/12,073ft)",
        activitydetails:
          "We climb the hill of Khumjung and descend to the east of the village by the wide valley that leads to the Dudh Koshi from where the road turns to the north. There are two trails and our guide will choose the best option to follow. There is a chorten at the top of the ridge at 3973m which descends from the Mt. Khumbila (5761 m). We visit Mohang, the birthplace of the reincarnated Lama of the Tibetan Monastery in Rongbuk, which allegedly introduced Buddhism into the Khumbu region of Nepal. The trail descends on a series of steep slopes down a sandy slope to Dush Koshi. We will spend the night at Phortse Tanga, near the river.",
      },
      {
        day: "Day 7",
        activity: "Phortse Thanga to Machhermo (4,470m/ 14,663ft)",
        activitydetails:
          "From Phortse Thanga, it's a difficult climb to Machhermo. Than we walk along a path of rhododendrons forest and crossed a waterfall before reaching the village of Tongba. We continue our hike up and through the villages of Dole, Labarma and Luza before arriving at Machhermo. There is a Chhorten just before the village of Luza. Throughout today's trip, we will walk along the Dudh Koshi River. Night in Machhermo.",
      },
      {
        day: "Day 8",
        activity: "Machhermo to Gokyo (4,800 m/15,744 ft)",
        activitydetails:
          "Today we start climbing a ridge for an excellent view of the Kangtaiga Valley and Cho Oyu (8153 m). The valley widens now as the trail crosses Phangkha, where an avalanche in 1995 killed 40 people. Then, we will go down to the edge of the river before climbing the moraine terminal of the Ngazumpa glacier by a steep path. Crossing an iron bridge over a stream, the trail rises as you follow the valley and pass the first lake, called Longpongo, at 4690m. At this point, we have the opportunity to observe the footsteps of a lama on a stone. Seeing the second lake, Taboche Tsho, we will be hypnotized by the shining sheet of turquoise blue water that shines in the sun. Shortly before the second lake, we reached the third lake, both connected by an updraft. The village of Gokyo is located next to the third lake and Cho-Oyu Mountain as a backdrop and offers amazing spectacular views. After lunch, we explore the third lake, Dudh Pokhari. Night in Gokyo.",
      },
      {
        day: "Day 9",
        activity:
          "Gokyo Valley: Acclimatization Day - Optional Hike to Gokyo Ri (5357 m/17,570 ft)",
        activitydetails:
          "In the morning, we will walk to Gokyo Ri, a small summit on the city of Gokyo, to enjoy fantastic views of the entire Khumbu region. As we ascend, the view becomes even more fantastic and we can see four of the seven highest peaks of Nepal, Cho Oyu, Everest, Lhotse and Makalu. After reaching the fourth lake, Thonak Tsho we can enjoy the serene beauty of the lake, after which we head back to the third lake. We can do an additional hike to the fifth lake, Ngozumba Tsho, weather permitting and depending on our physical conditions. From here, the view of the Ngozumba Glacier, the longest glacier in the Himalayas, is fascinating. Night in Gokyo.",
      },
      {
        day: "Day 10",
        activity: "Gokyo to Thagnak (4750 m/15,580 ft)",
        activitydetails:
          "If we had not climbed the Ri Gokyo the day before, we can do it today. Going up to the top of Gokyo Ri is demanding because it is steep and takes between 3 and 4 hours to reach the summit. But the landscape of the village of Gokyo, on the edge of the third lake overlooking Cholatse and the vast Nogzumpa Glacier, is magnificent. We are surrounded by scenic mountains like Kusum Kanguru, Thamserku, Kangtega, Taboche, Cholatse, Makalu, Lhotse, Nuptse, Everest, Changtse and Pumori. The view of the sun's rays embracing Everest, which rises above all the surrounding peaks, is astonishing. We walk along the Ngazumpa glacier to the mountain on the other side. Then, it crosses the edge of this mountain and then winds towards Thagnak. It will be a short walk today with a relaxing afternoon that will prepare us for long days of hiking and altitude gain to come. Night in Thagnak.",
      },
      {
        day: "Day 11",
        activity:
          "Thagnak to Cho La pass (5,367m/17,604 ft) to Dzongla (15, 939 ft)",
        activitydetails:
          "Today will be one of the most difficult days of the trip. The passage of Cho La is not difficult in itself, but it is steep and involves a glacier crossing on the east side. We must be careful because the road is vertical and the ice-covered rocks can cause problems to make the road slippery. The Phedi Trail crosses a ravine and a rocky trail. Walking along a frozen lake, we reach the top of the neck decorated with prayer flags. The pyramid Ama Dablam presides in the south a mountain range, even when Cholatse rises to the west and Lobuche East and Baruntse rise to our right. We must cross cracks before reaching the village of Dzongla. The village offers breathtaking views of Cholatse, Ama Dablam, the Lobuche Mountains and the village of Pheriche, which is well below.",
      },
      {
        day: "Day 12",
        activity: "Dzongla to Lobuche (4940 m/16,207 ft)",
        activitydetails:
          "It will be a very short walk, so we have plenty of time to relax and enjoy the beauty around us. We descend from Dzongla and walk on a grassy path while admiring the view of Lobuche Peak. The trail crosses the wide riverbed before reaching Lobuche. We can spend the rest of the day resting, which will help us prepare for the long journey of the next day. Night in Lobuche.",
      },
      {
        day: "Day 13",
        activity:
          "Lobuche to Gorak Shep (5,170 m/16,961ft), visit Everest Base Camp (5,364 m/17,594 ft)",
        activitydetails:
          "We take the road to reach Everest Base Camp through the vast Gorak Shep Lake. Continuing straight ahead, we find the memorials of the highlanders of the Indian army. The road from here can be misleading; therefore, it is important that we follow our Sherpa leader diligently. Walking is painful because of the lack of air in the heights. We cross rock dunes, moraines and streams before arriving at Everest base camp. Upon arriving at Everest base camp, we see mountaineering tents stand up in bright colors against the monotony of gray environments (especially in the spring). Nuptse, Khumbuste and Pumori are the visible mountains from the base camp. We return to Gorak Shep for a good rest. Overnight in Gorak Shep.",
      },
      {
        day: "Day 14",
        activity:
          "Gorak Shep to Kala Patthar (5,545m/18,192ft) to Pheriche (4,280 m/14,070 ft)",
        activitydetails:
          "We start early in the morning to climb to Kala Patthar. This is the most important day of our trip. We need to dress warmly for the trip, which will take us to the pre-dawn cold. We will climb two hours to reach Kala Patthar, the black rock that offers the best views of Everest. The view is so impressive that even the Everest Base Camp looks amazing. Nuptse, Chagatse, Lhotse and other mountains line up in front of us and reach as far as Tibet, to the north. We take a deep breath and slowly descend to Gorak Shep, and after breakfast, we trek to Pheriche. Overnight in Pheriche.",
      },
      {
        day: "Day 15",
        activity: "Pheriche to Namche Bazaar (3,438 m/11,280 ft)",
        activitydetails:
          "We take the same path, walking through the rhododendron and juniper forests to arrive at Tyangboche. It is a small village with a famous monastery offering panoramic views of Everest, Ama Dablam and Thamserku. We walk downhill to Namche Bazaar for the night. Overnight in Namche Bazaar.",
      },
      {
        day: "Day 16",
        activity: "Namche Bazaar to Lukla (2,800m/9,186ft)",
        activitydetails:
          "The trail descends steeply downward, so we need to be careful as our knees could feel a bit sore. Aside from that, we will feel great relief as the path becomes more flat and natural after the suspension bridges over the fast-flowing Dudh Koshi and its tributaries. After reaching Lukla, we stretch those sore legs and recall the experiences of the last couple of weeks. Overnight in Lukla.",
      },
      {
        day: "Day 17",
        activity: "Fly to Kathmandu",
        activitydetails:
          "We fly to Kathmandu in the morning. After returning to Kathmandu, you will be transferred to your hotel. There is nothing to do except for some last minute shopping or exploring other areas of Kathmandu. You can spend the evening leisurely or catch up on some last-minute shopping. Overnight in Kathmandu.",
      },
      {
        day: "Day 18",
        activity: "Departure from Kathmandu",
        activitydetails:
          "Your adventure in Nepal comes to an end today! A representative from Go Nepal will take you to the airport, approximately 3 hours before your scheduled flight. We hope you enjoyed your trip and we look forward to seeing you again!",
      },
    ],
    priceIncludes: [
      "Arrival/departure transfer to/from the international airport",
      "3 nights' accommodation with breakfast in a 3-star category hotel in Kathmandu",
      "A full day sightseeing tour in Kathmandu valley including a tour guide and transportation",
      "Meals (Breakfast, Lunch, and Dinner) with tea/coffee (twin sharing room) during the trek",
      "Twin sharing accommodation in the best available mountain lodges during the trek",
      "One English-speaking local expert guide, porters (1 porter for 2 trekkers), and their food, accommodation, salary & insurance",
      "Kathmandu-Lukla-Kathmandu domestic flight fare and airport tax",
      "Everest Conservation Area Project (ECAP) permit",
      "Sagarmatha National Park permit fee",
      "Down jacket and sleeping bag (to be returned after the trip)",
      "Nepal government tax and office service charge",
    ],
    priceExcludes: [
      "Nepal entry visa fee",
      "Travel insurance (mandatory)",
      "Lunch and dinner in Kathmandu",
      "International airfare to and from Kathmandu",
      "Personal expenses (phone calls, laundry, bar bills, battery recharge, extra porters, bottle or boiled water, shower, etc.)",
      "Tips for guide(s), porter(s) and driver(s)",
    ],
    usefulInformation: [
      "Trip duration: 18 days",
      "Maximum altitude: 5545 meters",
      "Starting and ending point: Kathmandu",
      "Accommodation: Hotel and mountain lodges",
      "Meals: Breakfast, lunch, and dinner during the trek",
      "Difficulty level: Strenuous",
      "Group size: Minimum 2 persons",
      "Best season: Spring (March to May) and Autumn (September to November)",
    ],
  },
  {
    destination_id: "makalu_base_camp_trek",
    title: "Makalu Base Camp Trek",
    price: "N/A",
    imageUrl: [
      // {
      //   id: 1,
      //   url: "/assets/destination/makalu/makalu1.jpeg",
      //   alt: "makalu basecamp trek",
      // },

      {
        id: 2,
        url: "/assets/destination/makalu/makalu2.jpeg",
        alt: "makalu basecamp trek",
      },

      {
        id: 3,
        url: "/assets/destination/makalu/makalu3.jpeg",
        alt: "makalu basecamp Trek",
      },
      {
        id: 4,
        url: "/assets/destination/makalu/makalu4.jpeg",
        alt: "makalu basecamp Trek",
      },
      {
        id: 5,
        url: "/assets/destination/makalu/makalu5.avif",
        alt: "makalu basecamp Trek",
      },
      {
        id: 6,
        url: "/assets/destination/makalu/makalu6.jpeg",
        alt: "makalu basecamp Trek",
      },
    ],
    description:
      "Makalu is the fifth highest mountain in the world (8,481 m), but the trek to its base camp is a less travelled route due to its relative inaccessibility",
    duration: "22 days",
    available: "Trekking & Hiking",
    OverviewSubHeading: "Makalu Base Camp Trek Some Quick Facts:",
    included:
      "All arrival and departure transfer in private vehicle, Hotels will be of tourist standard and during trekking will be local tea house/ guests house, All meals (lunch and dinner) as described in itinerary, A private vehicle as per group size, An English-speaking guide throughout the tour Trekking, TIMS and permit, 2 guests = 01 Porter, Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    OverviewDescription1: `Makalu is the fifth highest mountain in the world (8,481 m), but the trek to its base camp is a less travelled route due to its relative inaccessibility. The Makalu Base Camp trekking route is situated in the Makalu Barun National Park and Conservation Area, which is located in the heart of eastern Nepal. The main focus of this trek is the Makalu Barun National Park, located in the districts of Solukhumbu and Sankhuwasabha. The national park was founded in 1992. Previously, the Makalu trek was a restricted trekking area. It spans five major ecological zones, including the lush, tropical Arun valley, dense forests, rhododendrons, firs, and alpine meadows that lead to the massive Barun glacier. The main highlights of this trekking region are Chamlang Himal and the Barun Valley. The trekking areas of Makalu and Everest are not far apart. Trekking to Makalu Base Camp is a unique challenge. The Makalu Base Camp trek is one of Nepal's most remote and unexplored trekking areas.`,
    OverviewDescription2: `Natural wonders abound in the Makalu region. It stretches across many regions, where the cold of the mountain is chilling and the beauty of the mountain has an invincible air. Beautiful mountains, pristine forests, a diverse plant and animal life, and simple and warm-hearted people with rich and varied customs are among the highlights of this rich natural paradise. The Makalu Barun National Park is home to 3,000 plant species, 440 bird species, and 75 mammal species, including the snow leopard, red panda, musk deer, wild boar, wild yak, and Himalayan Thar. With the possibility of seeing wildlife at lower altitudes, green pastures and fields, villages and forests, as well as snow-capped mountains, glaciers, and rocky trails, this is also an ideal photography location. As a result, the Makalu trek is yet another popular trekking destination in Nepal.`,
    listofHighlights: [
      "The top 5 highest base camp in the world.",
      "View of Everest from a unique angle, as far away as Kangchenjunga.",
      "Kulung Valley with culture.",
      "Makalu and mount Chamlyaing view.",
      "Pass from green terraced farmland to glaciers and waterfalls.",
      "Trekking in the remote valley.",
      "Discover the rural life of the distinct culture of Rai and Sherpa in Nepal.",
      "Discover some of Nepal's rarest wild animals, including the red panda.",
      "Driving to the East Road in Nepal.",
      "Homestay trek.",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival in Kathmandu (1,300m/4,264ft)",
        activitydetails:
          "Upon arrival in Kathmandu, a representative of the Go Nepal will pick you up at the airport and take you the hotel where you can rest, refresh and even enjoy the local chai (tea). In the evening, a welcome dinner will be organized by the Taleju Adventure. For dinner, an excellent Nepali cuisine will be served to familiarize you with the culinary culture of the country. Overnight in Kathmandu.",
      },
      {
        day: "Day 2",
        activity: "Kathmandu Sightseeing",
        activitydetails:
          "Today, after breakfast, we begin our tour to some of the most historical and spiritual attractions of Kathmandu, also classified as UNESCO World Heritage. We visit historic Durbar Square, the sacred Hindu temple of Pashupatinath, the famous 'Monkey Temple' (Swayambhunath) and the Buddhist Sanctuary (Bouddhanath), which is also one of the largest stupas in the world. At the evening we got to meet each other in the hotel and discusses our trip for next day. Overnight in Kathmandu.",
      },
      {
        day: "Day 3",
        activity:
          "Fly from Kathmandu to Tumlingtar then drive to Chichira (1,980m/6497ft): 50 mins flight, 3-4 hours’ drive",
        activitydetails:
          "We fly to Tumlingtar after early morning breakfast and meet the rest of the crew who will also join us for the next day trek. Then we will drive to Chichira, a small village of Gurung. We will rest in Chichira because we must be ready for the next day trek. Night in Chichira.",
      },
      {
        day: "Day 4",
        activity: "Chichira to Num (1,560m/5119ft): 6-7 hours",
        activitydetails:
          "We start our trek early in the morning after breakfast and head to Num. A moderate walk through picturesque villages and leafy mountain forests will take us to Num. A ridge line with a magnificent view on both sides and at the end, this is Num for us. Night in Num.",
      },
      {
        day: "Day 5",
        activity: "Num to Seduwa (1,500m/4922 ft): 6-7 hours",
        activitydetails:
          "A steep descent through forests and terraced farms leads to the Barun River. We cross the river and follow a steep climb. Often quite hot here - the valley of the forest offers some shade as well. This is where the Makalu Barun National Park begins and we register our permits. We camp on top of the town. Night in Seduwa.",
      },
      {
        day: "Day 6",
        activity: "Seduwa to Tashigaon (2,100m/6890ft): 4-5 hours",
        activitydetails:
          "Ascend the ridge delimited to the west by Ipsuwa Khola and to the east by Kasuwa Khola. Crossing the hill through quiet villages and small rice fields, we reach the exotic village of Tashi Gaon. Once we reach there, we are surrounded by an impressive panorama of the Himalayas. Overnight in Tashigaon.",
      },
      {
        day: "Day 7",
        activity: "Tashigaon to Khongma Danda (3,500m/11,483 ft): 6-7 hours",
        activitydetails:
          "It will be a difficult day because we have to walk on a steep path in higher elevation. We will cross forests to reach a stream and a ridge. From there, the path becomes steeper and passes through a Jarka (grass) before following a series of stone stairs and small lakes that lead to the top of the ridge. From there, the trip to Khongma Danda is short. We will spend the night in Khongma Danda.",
      },
      {
        day: "Day 8",
        activity: "Acclimatization/Rest",
        activitydetails:
          "The rest day will allow a physical rest before crossing the Shipton La the next day. For those who wish to explore the surroundings, you can walk around the area. We will spend the night in Khongma Danda.",
      },
      {
        day: "Day 9",
        activity: "Khongma Danda to Dobate: 6-7 hours",
        activitydetails:
          "We climb to the top of Shipton La (pass) which takes a few hours to arrive at Keke La. After Lake Kalo Pokhari (3930 m), pass the Keke La at 4 170 m. We can see the wonderful views of Chamlang (7321m), Peak 6 (6,524m) and Peak 7 (6,758m). After crossing the pass of Keke La, we descend through the beautiful valley to Dobate. During the night in Dobate.",
      },
      {
        day: "Day 10",
        activity: "Dobate to Yangri Kharka (3,557m/11,670 ft): 6-7 hours",
        activitydetails:
          "From Dobate, we cross the rhododendron forest that leads to the Barun River and reaches the upper valley. We must be very careful during the first two hours of trek, since the road is steep and arduous. Then we take a pleasant walk taking altitude up to Yangri Kharka at the foot of the valley. We will spend the night in Yangri Kharka.",
      },
      {
        day: "Day 11",
        activity:
          "Yangri Kharka to Langmale Kharka: (4,410m/14,468ft): 5-6 hours",
        activitydetails:
          "After a moderate walk through the valley, we cross yak pastures, leafy forests and block fields. The walls of the valley are imposed on us at the beginning of the walk. We pass Merek as we make our way further up and we notice a significant increase in the panoramic views of the Himalayas. We will spend the night in Langmale Kharka.",
      },
      {
        day: "Day 12",
        activity:
          "Langmale Kharka to Makalu Base Camp: (4,870m/15,978ft): 6-7 hours",
        activitydetails:
          "Today is the day we arrive at the base camp. From Langmale Kharka, we climb to Shershong and finally to Makalu Base Camp. The path is flat with icy glaciers and snowy mountains that accompany us. Mount Makalu appears when we approaches Shershong. As we head towards the camp, we immerse into the majestic panorama of the Himalayas that surrounds us. We will spend the night in Makalu base camp.",
      },
      {
        day: "Day 13",
        activity: "Explore Makalu Base Camp",
        activitydetails:
          "The base camp is an arid and rocky place with the great Barun glacier beyond. From here we can see the magnificent south face of Makalu and the complete panorama of Everest and Lhotse. We can explore the surrounding lakes and glaciers and take a short walk to celebrate our achievements in the camp. We will spend the night in Makalu base camp.",
      },
      {
        day: "Day 14",
        activity: "Makalu Base Camp to Yangri Kharka: 6-7 hours",
        activitydetails:
          "We descend from the base camp and observe Makalu for the last time before turning the corner and returning back. As we descend, we cross Shershong, Langmale Kharka, Merek, descend into the valley and finally stop at Yangri Kharka. We will spend the night in Yangri Kharka.",
      },
      {
        day: "Day 15",
        activity: "Yangri Kharka to Dobate: 6-7 hours",
        activitydetails:
          "From Yangri Kharka, we descend through waterfalls, green forests and a valley to go to Dobate. We follow the banks of the Barun River along the road. During the night in Dobate.",
      },
      {
        day: "Day 16",
        activity: "Dobate to Khongma Danda: 5-6 hours",
        activitydetails:
          "We start the hike through a steep climb from Dobate to Mumbuk (Nambuk) and through a forest of fir and rhododendrons. We cross the Keke La, the Tutu La (Shipton Pass) and the Kauma La en route. Then we descend down to Khongma Danda. We will spend the night in Khongma Danda.",
      },
      {
        day: "Day 17",
        activity: "Khongma Danda to Tashigaon: 4-5 hours",
        activitydetails:
          "The walk continues with frequent and long and pronounced descents through the hills. The trail takes us through thick forests to the village of Sherpahs, in the Sherpa region. Overnight in Tashigaon.",
      },
      {
        day: "Day 18",
        activity: "Tashigaon to Seduwa: 4-5 hours",
        activitydetails:
          "We retrace our steps as we leave the Makalu Barun National Park and descend down to the Barun River. We cross the hill and cross villages and settlements as we descend and then finally stopping at Seduwa. Night in seduwa.",
      },
      {
        day: "Day 19",
        activity: "Seduwa to Num: 5-6 hours",
        activitydetails:
          "We leave Seduwa and cross leafy forests towards Num. The path climbs and descends through dense forests and Sherpa villages as we climb down before arriving at Num. Overnight in Num.",
      },
      {
        day: "Day 20",
        activity: "Num to Tumlingtar: 6-7 hours",
        activitydetails:
          "Once again, we return to Chichira, where we can enjoy the splendid view of Mount Makalu for the last time. The last stage of the trek will allow us to spend the night in Tumlingtar, ready for early departure to Kathmandu the next day. Overnight in Tumlingtar.",
      },
      {
        day: "Day 21",
        activity: "Tumlingtar to Kathmandu: 50 mins flight",
        activitydetails:
          "Today, we return to Kathmandu after our long trek in the mountains. We can rest and relax all day in our hotel or get in touch with our loved ones. In the evening, we celebrate our success at Makalu Base Camp with a farewell dinner. Overnight in Kathmandu.",
      },
      {
        day: "Day 22",
        activity: "Final departure",
        activitydetails:
          "Our trip to Nepal ends today. A representative of the Go Nepal will drop us off at the airport approximately 3 hours before our scheduled flight. On the way back, we will have plenty of time to plan our next adventure in the wonderful country of Nepal.",
      },
    ],

    priceIncludes: [
      "All arrival and departure transfer in private vehicle",
      "Hotels will be of tourist standard and during trekking will be local tea house/ guests house",
      "All meals (lunch and dinner) as described in itinerary",
      "A private vehicle as per group size",
      "An English-speaking guide throughout the tour Trekking",
      "TIMS and permit",
      "2 guests = 01 Porter",
      "Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    ],
    priceExcludes: [
      "Any kind of medical and personal insurance",
      "Any kind of personal nature items like bar and Laundry bills.",
      "Evacuation in case of emergency",
      "Domestic flights",
      "Tips to the guide and driver",
      "Entrance Fees",
      "ANY ITEMS NOT MENTIONED ABOVE",
    ],
    usefulInformation: [
      "The Makalu base camp trek is slightly more difficult than Everest base camp and Annapurna Circuit due to the incline, remoteness and rugged nature of the trails but extremely rewarding.",

      "March - May and September - November is the optimum months to visit Makalu Base Camp. The weather during this time allows the trekker to fully appreciated each beautiful aspect of the trip. In Autumn the temperature stands and pleasant and sunny in day time and won't be harshly colder in night. In Spring there is warm and sunny weather and witness of occasional snowfall at high altitude. When you pass through forest you there will be blooming of amazing red, purple, pink and white rhododendron and cloud forests through some of the last areas of pristine forest and meadows in Nepal. There is heavy rainfalls in the lower altitudes in Monsoon which cause floods and landslide. Due to rise in temperature.",

      "The trek starts in warm, terraced farmland inhabited by the rai people, an ethnic group found pre-dominantly in the hills of eastern Nepal.",
    ],
    equipments: [
      "One pair of sunglasses with good eye protection if you intend to climb glaciers.",
      "Head torch with extra batteries",
      "Multi-purpose Knife",
      "Camera Equipment",
      "Walking Stick",
      "One warm hat / sun hat",
      "Pair of waterproof broken in trekking shoes.",
    ],
    otherinfo:
      "A full day of exploration awaits you at Makalu Base Camp. As you ascend from 700m to over 5,000m, you will encounter a variety of scenery in various temperate zones. As you approach the base camp, the scenery is awe-inspiring in its grandeur and scale. On your day hike to the base camp, Makalu gradually reveals itself as you weave your way around the hillside, and the view from your lodge at MBC is breathtaking.",
  },

  {
    destination_id: "mardihimaltrek",
    title: "Mardi Himal Trek",
    price: "N/A",
    description:
      "Experience the Mardi Himal Trek, a hidden gem in the Annapurna region, with stunning vistas.",
    duration: "3 days",
    available: "N/A",
    included: "N/A",
    imageUrl: [
      {
        id: 1,
        url: "/assets/destination/mardi.jpeg",
      },
      {
        id: 11,
        url: "/assets/destination/mardi/mardi1.jpeg",
        alt: "mardi himal",
      },
      {
        id: 12,
        url: "/assets/destination/mardi/mardi2.jpeg",
        alt: "mardi himal",
      },
      {
        id: 13,
        url: "/assets/destination/mardi/mardi3.jpeg",
        alt: "mardi himal",
      },
      {
        id: 14,
        url: "/assets/destination/mardi/mardi4.jpeg",
        alt: "mardi himal",
      },
      {
        id: 15,
        url: "/assets/destination/mardi/mardi5.png",
        alt: "mardi himal",
      },
    ],

    OverviewSubHeading: "Highlights of the Annapurna Sanctuary Trek:",
    OverviewDescription1: `The Mardi Himal Trek is an ideal place for, a hiking experience, hiking in the surroundings and scenery of the Annapurna region, Nepal. The Annapurna range, in central Nepal, is home to some of the most iconic mountain scenery in the world and is crisscrossed by some of the country's most popular hiking trails. For those looking for a less travelled and smoother journey of this spectacular terrain, the 9 to 10 day walk through the Mardi Himal is perfect. Slightly more rigorous than your average mountain hike, the trek consists of walking up to the ridge that reaches the Annapurna. A breath-taking view of the lesser-known side of one of the most famous peaks - the Machhapuchhre (fishtail), 6993 meters high alone make the trek worth doing.`,
    OverViewDescription2: `Located just at the east of Nepal's, the most popular treks Mardi Himal is a hidden gem in the Annapurna region. Few hikers go to the Mardi Himal base camp located dramatically at the base of Mardi Himal and the impressive Machapuchhre. Another benefit of this trekking is that the trail has a small circuit to the Mardi Himal base camp so that we do not have to go back to the same terrain. The 10 day Mardi Himal trek is an easy and moderate level of travel for all travel enthusiasts. In conclusion, Mardi Himal trek is a short hike in the region of Annapurna in Nepal where we stay in lodges, try local dishes, enjoy the excellent landscape of hills and mountains; and awaken to the panoramic views of the massive Himalayan Mountains, including Annapurna, Machhapuchre, Hiunchuli and Mardi Himal.`,
    listofHighlights: [
      "Discover the city of Kathmandu and its heritage sites.",
      "Panoramic and close-up views of the Annapurna massif, explore the city of Pokhara on the shores of Lake.",
      "Unimpeded sunrise and sunset view from Poon Hill, picturesque villages.",
      "Experiencing the lifestyle and culture of Gurung and Magar people, who are very famous for Gorkha arm.",
      "Walk the narrow, cobbled path in the valley and the remote villages.",
      "Visit the old monastery, ancient tradition of the Gurung museum and waterfalls.",
      "Panoramic mountain flight to and from Pokhara.",
      "Walk through the dense forest of Rhododendron which is even more beautiful in the spring.",
    ],

    itinerary: [
      { day: "Day 01", activity: "Arrival, Transfer to hotel" },
      {
        day: "Day 02",
        activity: "Kathmandu Sightseeing, Trekking Preparation",
      },
      {
        day: "Day 03",
        activity:
          "Kathmandu - Lukla [2,800 m/9,184 ft]- Phakding (2,652 m/8,700 ft): 3-4 hrs",
      },
      {
        day: "Day 04",
        activity: "Phakding - Namche Bazaar [3,440 m/11,283 ft]: 5-6 hrs",
      },
      {
        day: "Day 05",
        activity:
          "Hike to Everest View Hotel(3780m/12400ft), Khumjung then back to Namche: 5-6 hrs",
      },
      {
        day: "Day 06",
        activity: "Namche Bazaar to Lukla (2,800m/9,186ft): 3-4 hrs walk",
      },
      { day: "Day 07", activity: "Fly back to Kathmandu" },
      { day: "Day 08", activity: "Departure" },
    ],

    priceIncludes: [
      "All arrival and departure transfers in a private vehicle",
      "Hotels will be of tourist standard, and during trekking will be local tea house/guest house",
      "All meals (lunch and dinner) as described in the itinerary",
      "A private vehicle as per group size",
      "An English-speaking guide throughout the tour and trekking",
      "TIMS and permit",
      "For 2 guests, 1 porter will be provided",
      "Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    ],

    priceExcludes: [
      "Any kind of medical and personal insurance",
      "Any kind of personal nature items like bar and laundry bills",
      "Evacuation in case of emergency",
      "Domestic flights",
      "Tips to the guide and driver",
      "Entrance fees",
      "ANY ITEMS NOT MENTIONED ABOVE",
    ],
    usefulInformation: [
      "Discover the natural and cultural splendors of Nepal and Bhutan.",
      "Explore Nepal's UNESCO World Heritage Sites.",
      "Hike to Bhutan's enchanting Tiger's Nest Monastery.",
      "Discover cultural and historical landmarks such as dzongs and temples.",
      "Take in the breathtaking sunrise and sunset views from among the tall and mighty peaks.",
    ],
  },

  {
    destination_id: "5",
    title: "Annapurna Sanctuary Trek",
    price: "£930",
    description:
      "The Annapurna Sanctuary Trek is a spectacular 14-day trip on the southern face of Annapurna I, offering a pleasant hike through the landscape and culture of Nepal. This trek leads to the fabulous amphitheater of highlands also known as Annapurna Base Camp. The route passes through waterfalls, impressive villages, terraced farmland, lush rhododendron forests, and remarkable mountain views before ascending to the steep Annapurna. This trek is an opportunity to witness the beautiful peaks of the Annapurna giants that surround the basin mountains in the Annapurna region.",
    duration: "14 days",
    available: "Trekking & Hiking",
    included: "N/A",
    imageUrl: [
      {
        id: 3,
        url: "/assets/destination/annapurnasantuary/annapurna3.jpeg",
        alt: "annapurna sanctuary",
      },
      {
        id: 11,
        url: "/assets/destination/annapurnasantuary/annapurna1.jpeg",
        alt: "annapurna sanctuary",
      },

      {
        id: 2,
        url: "/assets/destination/annapurnasantuary/annapurna2.jpeg",
        alt: "annapurna sanctuary",
      },

      {
        id: 4,
        url: "/assets/destination/annapurnasantuary/annapurna4.webp",
        alt: "annapurna sanctuary",
      },
      {
        id: 15,
        url: "/assets/destination/annapurnasantuary/annapurna5.webp",
        alt: "annapurna sanctuary",
      },
    ],
    OverviewSubHeading: "Annapurna Sanctuary Trek Overview:",
    OverviewDescription1: `The Annapurna Sanctuary Trek is a spectacular 14 days trip on the southern face of Annapurna I, a pleasant hike through the landscape and culture of Nepal. This walk leads to the fabulous amphitheater of highlands also known as Annapurna Base Camp. The course passes through waterfalls, impressive villages, terraced farmland, lush rhododendron forests and remarkable mountain views before heading the steep Annapurna. This is a good time to witness the beautiful peaks of the Annapurna giants that surround the mountains of the basin in the Annapurna region of the imperative center. Furthermore, a trip to Annapurna Base Camp is synonymous with entertainment and fun, as well as an extraordinary view of Nepal's plant and cultural heritage. This is by far one of the most enjoyable walks through various ethnic groups' lifestyles as well as the types of woods, plants, trees, and wildlife.`,
    OverViewDescription2: `The Annapurna Sanctuary is a high glacial basin located beneath a ring of eleven major peaks in Nepal. The Annapurna Sanctuary Trek takes you directly to the frozen heart of the Annapurna Range, a magnificent arena of rock and ice of epic proportions. The Annapurna Sanctuary Trek itinerary is designed for hikers who want to visit World Heritage sites and Poon Hill on their way to the Annapurna Base Camp in a relaxed manner. This allows enough time to admire the breathtaking peaks of all the Annapurna Giants that surround the Annapurna Basin Mountains from the center of the imperative, which includes Annapurna I, Hiunchuli, Annapurna II, Gangapurna, Annapurna III, Machhapuchhre, Annapurna IV, and others.`,
    listofHighlights: [
      "The Annapurna Sanctuary trek is an excellent introduction to Himalayan trekking.",
      "It is categorized as moderate and requires a basic level of fitness.",
      "Annapurna is the most dangerous 8000m peak to climb, with a fatality to successful climb ratio of 38%.",
      "The Annapurna massif is protected in the Annapurna Conservation Area, the largest protected area in Nepal.",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival in Kathmandu (1,300m/4,264ft)",
        activitydetails:
          "Our trip to Nepal starts today. A representative of the Go Nepal will greet you at the airport. Then we drop at your hotel, where you can rest, refresh and drink local tea. In the evening you can enjoy a welcome dinner organized by the Go Nepal. During dinner you can enjoy Nepalese cuisine. Overnight in Kathmandu.",
      },
      {
        day: "Day 2",
        activity: "Kathmandu: sightseeing and trek preparation",
        activitydetails:
          "Today we visit the World Heritage sites of UNESCO. These sites highlight Nepal's cultural and religious heritages. Our first stop will be Kathmandu's Durbar Square, followed by Swayambhunath Stupa, Pashupatinath Temple, and Boudhanath. Finally, late in the evening, we gather for a brief orientation on our hike for the next day. Overnight in Kathmandu.",
      },
      {
        day: "Day 3",
        activity:
          "Fly to Pokhara and trek to Ulleri (2050 m/6725 ft): 30 min flight and 6 hours trek",
        activitydetails:
          "We fly to Pokhara early in the morning. As soon as we land in Pokhara, we will notice the spectacular view of the Himalayas with which the city is adorned. From Pokhara, we head to Naya Pul and start the trek. We arrive in Ulleri in the evening. Overnight in Ulleri.",
      },
      {
        day: "Day 4",
        activity: "Ulleri to Ghorepani (2,750 m/ 9,020 ft): 4 - 5 hours trek",
        activitydetails:
          "After breakfast, we climb the village of Ghorepani by a stone staircase. As we ascend, we admire the spectacular scenery, while Annapurna South occupies an important place, which comes and goes from our point of view. Night in Ghorepani.",
      },
      {
        day: "Day 5",
        activity:
          "Ghorepani to Tadapani (2,700m/8,860ft) with a visit to Poon Hill (3,210m/10,529ft): 6 - 7 hours",
        activitydetails:
          "We wake up early in the morning to get to Poon Hill just in time to see the sunrise over the Himalayas. After returning to Ghorepani, we walk to Tadapani through rhododendron forests and waterfalls. Night in Tadapani.",
      },
      {
        day: "Day 6",
        activity: "Tadapani to Chhomrong (2170m/7120ft): 6 hours trek",
        activitydetails:
          "The trail begins with a descent into a large forest of rhododendrons and then opens onto magnificent terraced fields. We arrive in Chhomrong in the evening. Overnight in Chhomrong.",
      },
      {
        day: "Day 7",
        activity: "Chhomrong to Bamboo (2310m/7578ft): 4 - 5 hours",
        activitydetails:
          "We leave Chhomrong and walk on a series of stone steps before arriving at Chhomrong Khola. After crossing a suspension bridge, we trek to Bamboo. Night in Bamboo.",
      },
      {
        day: "Day 8",
        activity: "Bamboo to Deurali (3230m/10,595ft): 3 - 4 hours",
        activitydetails:
          "We trek through a bamboo forest and climb to Deurali, where we enjoy spectacular views of the surrounding hills and Mt. Dhaulagiri. Night in Deurali.",
      },
      {
        day: "Day 9",
        activity:
          "Deurali to Annapurna Base Camp (4,130m/13,545ft) via Machhapuchhre Base Camp (3700m/12135ft): 5- 6 hours",
        activitydetails:
          "We follow the valley path to Machhapuchhre Base Camp and then climb towards Annapurna Base Camp, where we are surrounded by beautiful peaks. Overnight at Annapurna base camp.",
      },
      {
        day: "Day 10",
        activity: "Annapurna Base Camp to Bamboo: 7 - 8 hours",
        activitydetails:
          "From Annapurna Base Camp, we descend to Bamboo. Today's descent is downhill, so it should not be very difficult. Night in Bamboo.",
      },
      {
        day: "Day 11",
        activity: "Bamboo to Jhinu Danda (1760m/5770 ft): 5 - 6 hours",
        activitydetails:
          "We return to Chhomrong and then descend to Jhinu Danda, where we can relax in natural hot springs. Overnight in Jhinu Danda.",
      },
      {
        day: "Day 12",
        activity:
          "Trek to Naya Pul then drive to Pokhara: 6 hours trek, 1 hour drive",
        activitydetails:
          "We trek to Naya Pul and drive to Pokhara. The trek to the Annapurna Sanctuary ends today. Overnight in Pokhara.",
      },
      {
        day: "Day 13",
        activity: "Fly from Pokhara to Kathmandu",
        activitydetails:
          "We fly to Kathmandu early in the morning. After landing, you will be dropped to the hotel. We celebrate the end of our trip with a farewell dinner. Overnight in Kathmandu.",
      },
      {
        day: "Day 14",
        activity: "Final departure",
        activitydetails:
          "Our trip to Nepal ends today. A representative will drop you off at the airport 3 hours before the scheduled flight.",
      },
    ],
    priceIncludes: [
      "All arrival and departure transfer in private vehicle",
      "3-star hotel in Kathmandu and Pokhara; tea houses/guest houses during trekking",
      "All meals (lunch and dinner) as described in the itinerary",
      "Private vehicle as per group size",
      "English-speaking guide throughout the tour",
      "Trekking TIMS and permit",
      "Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    ],
    priceExcludes: [
      "Medical and personal insurance",
      "Personal nature items like bar and laundry bills",
      "Emergency evacuation",
      "Domestic flights",
      "Tips to the guide and driver",
      "Entrance fees",
      "Any items not mentioned above",
    ],
    usefulInformation: [
      "The Annapurna Sanctuary trek is an excellent introduction to Himalayan trekking.",
      "It is categorized as moderate and requires a basic level of fitness.",
      "Annapurna is the most dangerous 8000m peak to climb, with a fatality to successful climb ratio of 38%.",
      "The Annapurna massif is protected in the Annapurna Conservation Area, the largest protected area in Nepal.",
    ],
  },

  {
    destination_id: "9",
    title: "Muktinath Yatra",
    price: "£600",
    imageUrl: [
      {
        id: 1,
        url: "/assets/destination/muktinath/muktinath1.jpeg",
        alt: "Muktinath",
      },
      {
        id: 2,
        url: "/assets/destination/muktinath/muktinath2.jpeg",
        alt: "Muktinath",
      },
      {
        id: 3,
        url: "/assets/destination/muktinath/muktinath3.jpeg",
        alt: "Muktinath",
      },
      {
        id: 4,
        url: "/assets/destination/muktinath/muktinath4.avif",
        alt: "Muktinath",
      },
      {
        id: 5,
        url: "/assets/destination/muktinath/muktinath5.jpeg",
        alt: "Muktinath",
      },
      {
        id: 6,
        url: "/assets/destination/muktinath/muktinath6.jpeg",
        alt: "Muktinath",
      },
      {
        id: 7,
        url: "/assets/destination/muktinath/muktinath7.jpeg",
        alt: "Muktinath",
      },
      {
        id: 8,
        url: "/assets/destination/muktinath/muktinath8.jpeg",
        alt: "Muktinath",
      },
      {
        id: 9,
        url: "/assets/destination/muktinath/muktinath9.jpeg",
        alt: "Muktinath",
      },
    ],
    description:
      "Embark on a spiritual journey to Muktinath, a sacred site revered by both Hindus and Buddhists as a place of liberation. This 7-day tour takes you through the historic city of Kathmandu, the tranquil lakeside town of Pokhara, and the mystical Mustang region where Muktinath Temple stands. Explore ancient temples, witness breathtaking mountain views, and immerse yourself in the rich cultural tapestry of Nepal.",
    duration: "7 days",
    available: "Religious & Spiritual Tours",
    OverviewSubHeading: "Overview:",
    included:
      "All the ground transportation by private vehicle, 2-way flight of Pokhara to Jomsom, Permit and entrance fee as per the itinerary, 3-night hotel in Kathmandu (Taleju Boutique hotel or similar), 2-night hotel in Pokhara (Hotel Lake paradise or similar), 1-night in Jomsom",
    OverviewDescription1: `Kathmandu is the capital city of Nepal. Kathmandu is the center of the Nepal’s history. Among 10 there are altogether seven world heritage sites in Kathmandu valley. Kathmandu is a historic valley and adjoining areas made up a confederation knows as Nepal Mandela which is the ancient civilization of Asia. Kathmandu has greatest concentration of temples, shrines, monasteries. The religious mix of Hindusim, Buddhism, Bon and Shamanism are intoxicating. It is a popular with tourists for unique architecture and rich culture that includes highest number of jatras in Nepal.`,
    OverviewDescription2: `Pokhara is known as the gateway to the Annapurna region, a popular trekking trail in the Himalayas. High above the placid phewa lake there is the peace pagoda. Sarangkot is a spectacular vintage point to watch sunrise and sunset on the Annapurna range. Tibetan refugee camps are located around the town and to the southeast is the narrow ravine of David’s fall. This is the place where you can relish complete recreational activities. You can also shopping in the streets and bazaars of pokhara city by getting spectacular view of the vegetation and the landscape view of city.
 Mustang is located at an altitude of 3,710 meters at the foot of the Himaayas – Thorang La mountain pass, Mustang. For both hindu and Buddhist pilgrims Muktinath is believe as  Mukti kshetra, which means the “place of liberation or moksha”. The central shrine of Mukthinath Temple is considered as one of the eight most sacref shrines for Hindu Vaishnavas known as Svayam Vyakta Kshetras. The major highlights of this muktinath tour is Tatopani, Marpha village Tour (the Apple capital in the nation with Marpha Brandy and Jams produced from local fruits), jomsom, Dhumba lake (lake is fed by ice melt from Mt.Nilgiri), kagbeni, 108 water spouts.
  `,
    listofHighlights: [
      "Weather condition of Muktinath",
      "Best season to visit Muktinath: Autumn (September, October, November)",
      "In spring (March, April, May), enjoy beautiful flora, spectacular mountain views, and moderate weather.",
      "Summer (June, July, August) is less suitable due to heavy rainfall, affecting transportation options.",
      "December, January, February: Trip completion depends on weather and temperature forecasts, with a possibility of snowfall.",
      "Equipment recommendations:",
      "- Autumn: Light jacket, windcheaters, autumn wear.",
      "- Spring: Warm light jackets, windcheaters, light clothes.",
      "- Summer: Light windcheaters, jackets, summer wear, raincoat.",
      "- Winter: Heavy down jackets, winter wear for cold weather.",
      "Mustang's inhabitants, of Tibetan and Thakali origin, celebrate festivals like Tiji, Lhosar, Duk Chu.",
      "Mustang is famous for Thakali food, local wines, apples, Tibetan bread, Marpha, and dried food.",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Kathmandu arrival",
        activitydetails:
          "On arrival at Tribhuvan International Airport in Kathmandu, our representative will greet and receive you at the airport. Then transfer to your hotel. After reaching your hotel, check in and take rest. Free in the evening. Overnight in hotel at Kathmandu.",
      },
      {
        day: "Day 2",
        activity: "Full day Kathmandu sightseeing",
        activitydetails:
          "After breakfast, embark on a full-day sightseeing tour of Kathmandu. Visit Pashupatinath, Boudhanath, Swayamhbunath, and Jalanayan Temple. Overnight in hotel at Kathmandu.",
      },
      {
        day: "Day 3",
        activity: "Drive to Pokhara enroute visit Manokamna Temple",
        activitydetails:
          "After breakfast, drive to Pokhara. En-route, visit Manokamna Temple in Gorkha district. Upon reaching Pokhara, transfer to a hotel near Phewa Lake. Enjoy an evening stroll around the lakeside. Overnight in hotel at Pokhara.",
      },
      {
        day: "Day 4",
        activity: "Flight from Pokhara to Jomsom and visit Muktinath temple",
        activitydetails:
          "Transfer to Pokhara airport for a flight to Jomsom. Upon arrival, drive to Muktinath Temple via Kagbeni. Explore the sacred site and its surroundings. Overnight in Jomsom.",
      },
      {
        day: "Day 5",
        activity: "Flight back to Pokhara and sightseeing",
        activitydetails:
          "After breakfast, fly back to Pokhara. Proceed for sightseeing at Davis falls, Gupteshwor Cave, and Seti River Gorge. Enjoy a leisurely evening walk around Phewa Lake. Overnight in hotel at Pokhara.",
      },
      {
        day: "Day 6",
        activity: "Drive back to Kathmandu",
        activitydetails:
          "Check out from the hotel in Pokhara after breakfast and drive back to Kathmandu. Enjoy shopping or explore the old city upon arrival. Overnight at Kathmandu.",
      },
      {
        day: "Day 7",
        activity: "Final Departure",
        activitydetails:
          "Our representative will transfer you to Tribhuvan International Airport for your departure.",
      },
    ],
    priceIncludes: [
      "All the ground transportation by private vehicle",
      "2-way flight of Pokhara to Jomsom",
      "Permit and entrance fee as per the itinerary",
      "3-night hotel in Kathmandu (Taleju Boutique hotel or similar)",
      "2-night hotel in Pokhara (Hotel Lake paradise or similar)",
      "1-night in Jomsom",
    ],
    priceExcludes: [
      "All the natural personal expenses",
      "Drinks and bar bills",
      "Extra activities other than the itinerary",
      "Other costs which are not included in the cost included",
    ],
    usefulInformation: [
      "Muktinath is surrounded by rugged, snow-clad mountains lies at an altitude of 3750m.",
      "Kathmandu to Muktinath is about 375 Km one way, with about 300 kilometers of good, well-paved road and the rest being rough mountain road.",
      "Weather conditions vary depending on the season, with autumn and spring being the most favorable for visiting Muktinath.",
    ],
  },
  {
    destination_id: "10",
    title: "Manaslu Circuit Trek",
    price: "N/A",
    imageUrl: [
      {
        id: 5,
        url: "/assets/destination/manaslu/manaslu5.webp",
        alt: "manaslu circuit Trek",
      },
      {
        id: 1,
        url: "/assets/destination/manaslu/mansalu1.jpeg",
        alt: "manaslu circuit trek",
      },
      {
        id: 2,
        url: "/assets/destination/manaslu/manaslu2.jpg",
        alt: "manaslu circuit Trek",
      },
      {
        id: 3,
        url: "/assets/destination/manaslu/manaslu3.jpeg",
        alt: "manaslu circuit Trek",
      },
      {
        id: 4,
        url: "/assets/destination/manaslu/manaslu4.jpeg",
        alt: "manaslu circuit Trek",
      },

      {
        id: 6,
        url: "/assets/destination/manaslu/manaslu6.jpeg",
        alt: "manaslu circuit Trek",
      },
    ],
    description:
      "Embark on an adventurous journey through the breathtaking landscapes and rich cultural heritage of the Manaslu region with the Manaslu Circuit Trek. This 18-day trekking adventure takes you through remote villages, lush forests, and rugged mountain passes, offering stunning views of the Himalayas. Encounter diverse wildlife and immerse yourself in the unique blend of Tibetan and Nepalese culture as you traverse this challenging yet rewarding trek.",
    duration: "18 days",
    available: "Trekking & Hiking",
    OverviewSubHeading: "Overview",

    OverviewDescription1: `The Manaslu Circuit is a newly opened promenade for visitors from all over the world that is a wonderful blend of Nepal's natural splendour and cultural mix. The Manaslu region, which opened in 1992, has become a magnet for tourists and adventurers interested in trekking in Nepal. Thus, Manaslu has managed to pique the interest and curiosity of travelers who actually visit this location. With the inclusion of the well-trodden path, the Manaslu Trek tour is rich in beauty. As you travel along the trail, you will encounter a wide range of climatic, vegetation, cultural, and wildlife diversity. Beyond the Manaslu conservation area, this area is rich in flora and fauna, and if you're lucky, you might spot some species along the way. The Manaslu region trek is a remarkable place to welcome the magnificence of Mt. Manaslu, the world's eighth highest mountain. This area's exuberant environment in the interior of the Dwarf Mountains is a blessing for anyone seeking peace and happiness in the midst of nature.`,
    OverViewDescription2: `One of these beautiful treks is the Manaslu Trek circuit, which is also one of the most difficult routes in Nepal. The round of Manaslu Trek will provide adventurers with exceptional alpine fun. Because there are few visitors to this area, the trails are less crowded, making it a quiet, natural, and beautiful experience that is also ideal for those looking to get away from the hustle and bustle of everyday life. Not only is the haunting natural beauty a highlight of the trip, but so are the traditional Tamang and Sherpa settlements with their distinct cultures. The Manaslu Trek circuit begins in Kathmandu, where we visit UNESCO World Heritage sites, and ends in Arughat, where the trek itself begins. The entire course is adorned with perfect views of snow-capped mountains, a one-of-a-kind combination of rich cultural heritage and adventures set among vistas of unparalleled beauty and rare biodiversity.`,

    included:
      "All arrival and departure transfer in private vehicle, 3-star hotel in Kathmandu and during trekking will be local tea house/guest house, All meals (lunch and dinner) as described in the itinerary, A private vehicle as per group size, An English-speaking guide throughout the tour, Trekking TIMS and permit, 2 guests = 01 Porter, Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    listofHighlights: [
      "Stunning natural beauty of the forests, rivers, and flora of the Manaslu region.",
      "Rich culture of the region, including Nepalese and Tibetan ethnic groups.",
      "Larky La Pass (5167 meters), the highest point of the trek.",
      "Breathtaking views of Manaslu, Cheo Himal, Himalung Himal, Nemjung, Gyaji Kang, Kang Guru, and Annapurna II.",
      "Abundant wildlife including Tahr (mountain goat), Agali (blue sheep), pika, Himalayan marmots, and if lucky, Snow Leopard.",
      "Scenic walk through the Budi Gandaki valley.",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival in Kathmandu [1,300m/4,264 ft]",
        activitydetails:
          "Upon arrival at the Tribhuwan International Airport (TIA) in Kathmandu, you will be greeted by a representative of the Go Nepal who then will drop you off at the hotel. After check-in, you can rest, refresh yourself and enjoy the local tea. In the evening, a welcome dinner will be organized by the Go Nepal. Overnight in Kathmandu.",
      },
      {
        day: "Day 2",
        activity: "Kathmandu: Sightseeing and Trek Preparation",
        activitydetails:
          "Today, after breakfast, we begin a tour to many of Kathmandu's most historical and spiritual attractions. Some of these sites, including the historic Durbar Square, the sacred Hindu temple of Pashupatinath, the famous 'Monkey Temple' (Swayambhunath), and the Buddhist Sanctuary (Bouddhanath), are listed as UNESCO World Heritage Sites. There will be a brief group discussion before the trip, followed by a late evening trekking preparation at the Hotel where your accommodation is. Overnight in Kathmandu.",
      },
      {
        day: "Day 3",
        activity:
          "Drive from Kathmandu to Sotikhola [710m/2328 ft] 8 - 9 hours",
        activitydetails:
          "We leave early today for Sotikhola. During the trip, we enjoy a view of the Nepalese countryside and the mountains. We will drive along a paved road that connects Kathmandu with Dhading Bensi, District headquarters (1050 m) of Dhading, but the trip from Dhanding Bensi to Arughat will be difficult. Arriving at Arughat, an important city in the region, we continue our way to Sotikhola. We will spend the night in Soti Khola.",
      },
      {
        day: "Day 4",
        activity: "Soti Khola - Maccha Khola [900m/2952 ft]: 6 - 7 hours",
        activitydetails:
          "After crossing the bridges, we stroll through the beautiful forests of Sal, then climb a ridge over the huge rapids in the Budhi Gandaki. Then we arrive at Khursane, where the rocky trail sneaks between two tropical waterfalls on a steep rocky path that hangs on the edge of a cliff. It ends up going down some terraced rice fields, and then goes up to the Gurung village of Labubesi. We climb further behind a rocky promontory, where the valley opens and Budhi Gandaki meanders between large gravel bars. As we descend to the sandy bed of the river, we walk on rounded stones before climbing a side ridge. We go down to the river and cross another suspension bridge to reach the town of Machha Khola. We will spend the night in Machha Khola.",
      },
      {
        day: "Day 5",
        activity: "Maccha Khola -Jagat [1410m/ 4625 ft]: 6 - 7 hrs",
        activitydetails:
          "The narrow track makes some ups and downs and finally crosses the Tharo Khola to get to Kohlrabies. After a few more ups and downs, we came across a small Hotspring in Tatopani. From the hot springs, we climb another ridge, then cross Budhi Gandaki on a suspension bridge. At this point, we climb a wide, well-designed staircase, then cross a landslide and again cross a ridge towards Dobhan. After crossing a suspension bridge over the Yaru Khola, we climb the stone stairs, then descend to the river and climb again several stone steps leading to Tharo Bharyang. Crossing the west bank of Budhi Gandaki, we climb a ridge, walk along the river, and then climb the village of Jagat. Overnight in Jagat.",
      },
      {
        day: "Day 6",
        activity: "Jagat - Deng [1,804m/5917 ft]: 6 - 7 hrs",
        activitydetails:
          "We start today's walk climbing a rocky ridge to Salleri, then down to Sirdibas. The valley widens a little while the trail continues to Ghatta Khola. We then continue walking through a long suspension bridge towards Philim, a large village of Gurung. The road turns north just above the lowest house in the village and stays on a fairly flat road while crossing the millet fields towards Ekle Bhatti. The road now enters a steep, uninhabited gorge. At this point, we descend the grassy slopes, cross Budhi Gandaki, continue a long journey along the west bank and then return to the east bank. Continuing down the road, the valley widens and we pass through bamboo forests to Deng Khola. Crossing the Khola, we arrive at the small village of Deng. Overnight in Deng.",
      },
      {
        day: "Day 7",
        activity: "Deng - Namrung [2630m/8626ft]: 6 - 7 hrs",
        activitydetails:
          "After a short walk past Deng, we cross Budhi Gandaki and climb to Rana at 1910 m. From the bridge, we climb a bit to get to a path of Bhi, then we head west in the valley of Budhi Gandaki. The road also crosses forests and mani where we turn towards a corner overlooking Ghap. Even if there is another route, we take the route through the village of Prok. The village of Prok has a beautiful view of Siringi Himal. We cross the Budi Gandaki several times and find several gompas on the way. The trail follows the river upstream through dense forests. After crossing the river to an impressive place where it breaks a narrow gorge, the forest becomes less dense and the trail becomes good again. The walk continues and after a final steep climb we reach Namrung. Night in Namrung.",
      },
      {
        day: "Day 8",
        activity: "Namrung – Samagaon [3530m/11,578 ft]: 6-7 hours",
        activitydetails:
          "The village of Namrung is a good point of view for Siring and Ganesh Himal and from the village you can also see Mt. Himal Chuli in the south. We climb regularly and cross forests to reach Lihi, a beautiful village with many chortens and barley terraces. The trail descends and crosses the Simnang Himal with Ganesh Himal always nearby. We then cross the villages of Sho, Lho and Shyala before reaching the village of Sama. We enjoy an extraordinary view of the Mt. Manaslu from the village of Lho and also explore the famous Ribung Gompa. In the village of Shyala, we will be surrounded by high mountains such as Himal Chuli and Peak 29 (Ngadi Chuli) on the left, Manaslu and large glaciers in front of you, as well as other snow-capped peaks on the right and at the end, Ganesh Himal too. Today's trip ends in Samagaon where we spend the night.",
      },
      {
        day: "Day 9",
        activity:
          "Samagaon - Pungyen gompa - Samagaon: 6 - 7 hours exploration",
        activitydetails:
          "We spent the day in Samagaon for both rest and acclimatization. Today we are familiar with the rich Sherpa culture. We enjoy the view of thousands of mani stones with Buddhists text and images and Sherpa women dressed in traditional clothes and ornaments. On a small hill near the village of Sama there is an old Gompa (Pungyen Gompa), a monastery with a magnificent view of the glacier. It is called Manaslu, Pungyen means bracelet, a good description of the two peaks. It was destroyed a year after the first unsuccessful attempt by the Japanese to climb Manaslu. The locals thought that the climbing irritated the gods and when the Japanese returned a year later, they encountered many resistances that forced them to abandon their attempt. Finally they achieved it in 1959. Overnight in Samagaon.",
      },
      {
        day: "Day 10",
        activity: "Samagaon - Samdo [3860m/12,660 ft]: 4 - 5 hours",
        activitydetails:
          "Today, we descend to the Budhi Gandaki River, which has headed north, and follow it to a bridge that crosses a stream. The road to the left leads to the Manaslu base camp. The Larkya trail passes through several walls of mani when the valley begins to widen. It is an easy path on a platform over the river through the juniper and birch forests of Kermo Kharka. We leave the plateau, crossed Budhi Gandaki on a wooden bridge and climbed abruptly on a promontory between two arms of the river. From a stone arch, we can see a large white kani. Finally, crossing the kani, we find Samdo. Overnight in Samdo.",
      },
      {
        day: "Day 11",
        activity: "Rest Day in Samdo",
        activitydetails:
          "This is another day reserved for proper acclimation. There are two options for us today. The option that we strongly recommend is a walk through the valley directly in the back of the village of Samdo. This walk will take us to one of the commercial passes to Tibet to get excellent views of Mt. Manaslu along with other ranges of the Himalayas, including Simrang, Hiunchuli, Ngadi, Larkye Peak, Cheo and possibly Kang Guru behind the pass. En route to these points of view, we pass by many seasonal grazing settlements called doksas and observed some beautiful mountain birds such as the Lophophorus (the national bird of Nepal), Lammergeyer and the Griffin Himalayas flying above us. Another option for today could be a trip to Gya La ('grand pass') to the north of Samdo, a most used trade route to Tibet. But, this is a much longer walk (all day) and therefore it could be a bit strenuous. Overnight in Samdo.",
      },
      {
        day: "Day 12",
        activity:
          "Samdo - Dharamsala/Larkya B. C. [4460m/14, 628 ft]: 4 - 5 hours",
        activitydetails:
          "Even today, we continue our walk on the edge, cross the wooden bridge on Budi Gandaki and start climbing. After crossing two streams and observing the Larkya Glacier, we round the valley of the Salka Khola and go back to the stone guest house (4450 m), which is not a lodge but a kind of shelter called Dharmshala, also known as Larke Phedi. Today's short walk also leaves plenty of time to acclimatize and relax in the afternoon. Overnight in Dharmashala.",
      },
      {
        day: "Day 13",
        activity:
          "Dharamsala - Larkya la [5160m/16, 924 ft] - Bimthang [3720m/12, 201 ft]: 8 - 9 hours",
        activitydetails:
          "After a short climb, we arrive at a valley on the north side of the Larkya glaciers from where we can enjoy magnificent views of Cho Danda and Larkya Peak. Finally, we cross the moraines of the glacier making a gradual ascent that does not become more rigid than in the last part of the pass. From the pass, there is an exceptional view of Himlung Himal, Cheo Himal, Kangguru and the huge Annapurna II. For Bimtang, the day is longer than normal, but you have to walk in these pastures with the fog in the afternoon with the mountain. Near Manaslu is an exciting experience. Night in Bimthang.",
      },
      {
        day: "Day 14",
        activity: "Bimthang - Tilije [2300m/7544ft]: 5 - 6 hours",
        activitydetails:
          "From a ridge in Bimthang, we can enjoy excellent views of the Mt. Manaslu, Lamjung Himal, Himlung Himal and Cheo Himal. We go further and cross a high pasture (Blood of Kharka) followed by a bridge over Dudh Khola. We cross a forest of rhododendrons and follow a path in a narrow valley to the highest cultivated land in the valley at Karche, 2785 meters. We cross fields before making a strong climb on a ridge. The trail leaves the ridge in a large arch on the riverbank at 2580m. A little further away is the village of Gho. Due to the tiredness of the previous day, we could rest during the night in Gho, but there are better accommodations available in Tilije. We will spend the night in the village of Tilije.",
      },
      {
        day: "Day 15",
        activity: "Tilije - Tal [1700m/5576 ft]: 5 - 6 hours",
        activitydetails:
          "We climb a small ridge and enjoy the paved stone path that runs through a beautiful village. We cross the bridge over Dudh Khola and climbed a chorten arch, passed a mani wall and arrived at the village of Thonje. In the village, we pass a police checkpoint and continued to Dharapani. We entered the section of the Annapurna circuit from Dharapani. Further down, we cross the village of Karte and, after a good walk, cross a bridge in Marshyangdi Khola. We will also find some mani walls before reaching the town of Tal, located at the foot of a large waterfall. Night in Tal.",
      },
      {
        day: "Day 16",
        activity: "Tal - Syange [1080m/3542 ft]: 6 - 7 hours",
        activitydetails:
          "We follow the road to the village of Chyamje crossing the Marshyangdi Khola once more. The valley of Marsyandi opens with its terrace fields and very high hillside villages. The trail then descends through the rhododendron and pine forests and Syange. Overnight in Syange.",
      },
      {
        day: "Day 17",
        activity: "Syange - Kathmandu: 8-9 hours",
        activitydetails:
          "The road from Syange to Kathmandu through Besi Sahar offers the opportunity to enjoy the Hilly and Mountainous landscapes. The route is usually on the banks of the Marsyangdi and Trishuli rivers. We also pass through beautiful villages with agricultural terraces on both sides of the road. In Kathmandu, we will be escorted to our hotel. To celebrate the success of our trip, we will have a farewell dinner at night. Overnight in Kathmandu.",
      },
      {
        day: "Day 18",
        activity: "Final departure",
        activitydetails:
          "Your adventure ends today. There is nothing more to do than exchange emails with other travellers and organize photos. A representative of the Go Nepal will accompany you to the airport approximately 3 hours before the planned flight. On the way you will have plenty of time to plan our next adventure in the wonderful country of Nepal.",
      },
    ],
    priceIncludes: [
      "All arrival and departure transfer in private vehicle",
      "3 star hotel in Kathmandu and during trekking will be local tea house/ guests house",
      "All meals (lunch and dinner) as described in itinerary",
      "A private vehicle as per group size",
      "An English-speaking guide throughout the tour",
      "Trekking TIMS and permit.",
      "2 guests = 01 Porter",
      "Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    ],
    priceExcludes: [
      "Any kind of medical and personal insurance",
      "Any kind of personal nature items like bar and Laundry bills.",
      "Evacuation in case of emergency",
      "Domestic flights",
      "Tips to the guide and driver",
      "Entrance Fees",
      "ANY ITEMS NOT MENTIONED ABOVE",
    ],

    usefulInformation: [
      "The Manaslu Circuit is open from March to June and September to November.",
      "The region is extremely rich in wildlife, adding to the adventure of the journey.",
      "The Manaslu Circuit trek is a challenging journey in Nepal's northwestern region.",
      "The Manaslu Circuit Trek is known for its unique blend of Tibetan and Nepalese culture.",
      "The Manaslu Circuit is open from March to June and September to November",
      "The region is extremely rich in wildlife, adding to the adventure of the journey",
      "The Manaslu Circuit trek is a challenging journey in Nepal's northwestern region",
      "The trek is known for its unique blend of Tibetan and Nepalese culture",
    ],
  },

  {
    destination_id: "langtang_gosainkunda_and_helambu_trek",
    title: "Langtang, Gosainkunda And Helambu Trek",
    price: "N/A", // Fill this with appropriate data if available
    duration: "17 days",
    description:
      "Langtang Gosaikunda and Helambu Trekking combines three distinct locations for comprehensive coverage...",
    available: "", // Fill this with appropriate data if available
    included:
      "All arrival and departure transfer in private vehicle, Hotels will be of tourist standard and during trekking will be local tea house/ guests house, All meals (lunch and dinner) as described in itinerary, A private vehicle as per group size, An English-speaking guide throughout the tour Trekking, TIMS and permit, 2 guests = 01 Porter, Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    imageUrl: [
      {
        id: 5,
        url: "/assets/destination/ghosaikunda/ghosaikunda2.jpeg",
      },
      {
        id: 1,
        url: "/assets/destination/gosaikunda.jpeg",
      },

      {
        id: 4,
        url: "/assets/destination/ghosaikunda/ghosaikunda.jpeg",
      },
      {
        id: 3,
        url: "/assets/destination/ghosaikunda/ghosaikunda3.jpeg",
      },
      {
        id: 2,
        url: "/assets/destination/ghosaikunda/ghosaikunda4.jpeg",
      },
    ],
    OverviewSubHeading: "Some Trip Highlights",
    OverviewDescription1: "Max. Altitude: Gosaikunda Lake (4460m/14632ft).",
    OverViewDescription2: "Trek Grade: Fairly Strenuous.",
    listofHighlights: [
      "Tserko Ri to see a range of mountains.",
      "Gosainkunda, a mythological lake.",
      "Langtang National Park, home to 7000 m peaks and Red Panda.",
      "Village of Helambu, where the culture is intact.",
      "Kyanjin Gompa to enjoy yak cheese and a view of the glacier surrounded.",
      "Transportation: Local Bus/Private Vehicles/Tourist Bus",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival in Kathmandu (1,350m/4,428ft)",
        activitydetails:
          "After landing at the Tribhuwan International Airport, you will be greeted by a representative of the Go Nepal...",
      },
      {
        day: "Day 2",
        activity: "Kathmandu: sightseeing and trek preparation",
        activitydetails:
          "Today, after early morning breakfast, we begin a tour to many of Kathmandu's most historical and spiritual attractions...",
      },
      {
        day: "Day 3",
        activity:
          "Drive from Kathmandu to Syabrubesi (1,550m/5,100ft): 7-8 hours",
        activitydetails:
          "Today we leave Kathmandu in the morning for Syabrubesi, a village that is also the starting point for treks in the Langtang Valley...",
      },
      {
        day: "Day 4",
        activity:
          "Trek from Syabrubesi to Lama Hotel (2,380m/7,830ft): 6 hours",
        activitydetails:
          "After breakfast, we start our trip to Syabrubesi along the Langtang Khola. We ascend and descend simultaneously through oak and rhododendron forests...",
      },
      {
        day: "Day 5",
        activity:
          "Trek to Mundu (3543m/11,621ft) via Langtang village: 6-7 hours",
        activitydetails:
          "We continue our ascent from the hotel Lama and enjoy the mountainous landscape with its numerous waterfalls. When we arrive in the green pastures of Ghoda Tabela...",
      },
      {
        day: "Day 6",
        activity: "Mundu to Kyangjin Gompa (3,870m/12,697ft): 4-5 hours",
        activitydetails:
          "After breakfast, we will start our trip to Kyangjin Gompa, one of the main monasteries in the area...",
      },
      {
        day: "Day 7",
        activity:
          "Acclimatization- Explore Tserko Ri (5000m/16,404ft) 7-8 hours",
        activitydetails:
          "We spend the whole day exploring Tserko Ri, which will also help us get used to the altitude. We start early in the morning...",
      },
      {
        day: "Day 8",
        activity: "Kyangjin Gompa to Lama Hotel: 6-7 hours",
        activitydetails:
          "We start our walk after breakfast and retrace our steps to the Lama Hotel. Most of today's hikes will be downhill...",
      },
      {
        day: "Day 9",
        activity: "Lama Hotel to Thulo Syabru (2,230m/ 7,316 ft): 5-6 hours",
        activitydetails:
          "We start our walk with a climb to the village of Rimche. From here we descend to the banks of Langtang Khola...",
      },
      {
        day: "Day 10",
        activity: "Thulo Syabru to Shin Gompa: 3-4 hours",
        activitydetails:
          "The stroll will be short today, but it is important not to go to Gosaikunda today, as the constant gain in altitude will help us acclimatize to this altitude...",
      },
      {
        day: "Day 11",
        activity: "Shin Gompa to Gosaikunda (4,460m/14,632ft): 5-6 hours",
        activitydetails:
          "Today we can enjoy fantastic panoramic views of the Himalayas, including the Annapurnas, Hiunchuli, Manaslu, Ganesh and Langtang...",
      },
      {
        day: "Day 12",
        activity: "Gosaikunda to Ghopte (3,440m/11,286ft): 6-8 hours",
        activitydetails:
          "We move around the lake before climbing to the Laurebina pass (4610 m). The region of Helambu begins at Lauribina La (walk) and descends into the Melamchi Valley...",
      },
      {
        day: "Day 13",
        activity: "Ghopte to Melamchigaon (2,560m/8,399ft): 6-7 hours",
        activitydetails:
          "We go up and down a path through dense forests. Walking on a path through the forest will take us to Thare Pati Village...",
      },
      {
        day: "Day 14",
        activity: "Melamchigaon to Tarkeghyang (2,590m/8,497ft): 5-6 hours",
        activitydetails:
          "We pass through a stupa and cross a small stream below Tarkeghyang...",
      },
      {
        day: "Day 15",
        activity: "Tarkeghyang to Sermathang (2,610m/8,563ft): 3-5 hours",
        activitydetails:
          "We start our walk after breakfast. The path is easy and passes through lush forests...",
      },
      {
        day: "Day 16",
        activity:
          "Trek to Melamchi Bazaar, drive to Kathmandu: 3-4 hours trek, 2 hours’ drive",
        activitydetails:
          "We walk through meadows, fields and beautiful villages to reach the Melamchi Bazaar...",
      },
      {
        day: "Day 17",
        activity: "Final Departure",
        activitydetails:
          "Our trip to Nepal ends today. A Go Nepal representative will drop you off at the airport about 3 hours before our scheduled flight...",
      },
    ],

    priceIncludes: [
      "All arrival and departure transfer in private vehicle",
      "Hotels will be of tourist standard and during trekking will be local tea house/ guests house",
      "All meals (lunch and dinner) as described in itinerary",
      "A private vehicle as per group size",
      "An English-speaking guide throughout the tour Trekking",
      "TIMS and permit",
      "2 guests = 01 Porter",
      "Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    ],
    priceExcludes: [
      "Any kind of medical and personal insurance",
      "Any kind of personal nature items like bar and Laundry bills.",
      "Evacuation in case of emergency",
      "Domestic flights",
      "Tips to the guide and driver",
      "Entrance Fees",
      "ANY ITEMS NOT MENTIONED ABOVE",
    ],
    usefulInformation: [
      "Langtang Gosainkunda Helambu Trekking offers breathtaking mountain views, culture, flowers, and fauna as you progress from one area to another.",
      "The Langtang Gosaikunda Helambu trek is a memorable adventure in Nepal's Himalayan region.",
      "You can enjoy the Panoramic views from Kyanjin Gompa.",
    ],
  },

  {
    destination_id: "1111",
    title: "Ghorepani - Poon-Hill Trek",
    duration: "9 days",
    activity: "Trekking & Hiking",
    price: "N/A",
    included: "Trekking & Hiking",

    imageUrl: [
      {
        id: 1,
        url: "/assets/destination/ghorepani/ghorepani1.jpeg",
        alt: "ghorepani",
      },
      {
        id: 2,
        url: "/assets/destination/ghorepani/ghorepani2.jpeg",
        alt: "ghorepani",
      },
      {
        id: 3,
        url: "/assets/destination/ghorepani/ghorepani3.jpeg",
        alt: "ghorepani",
      },
      {
        id: 4,
        url: "/assets/destination/ghorepani/ghorepani4.jpeg",
        alt: "ghorepani",
      },
      {
        id: 5,
        url: "/assets/destination/ghorepani/ghorepani5.jpeg",
        alt: "ghorepani",
      },
      {
        id: 6,
        url: "/assets/destination/ghorepani/ghorepani6.jpeg",
        alt: "ghorepani",
      },
    ],

    description:
      "Embark on one of the most exciting and impressive treks with the Ghorepani - Poon-Hill Trek. This evergreen route takes you through historic ethnic villages and offers stunning views of the Himalayas. Poon Hill, at an elevation of 3,210 meters, provides a panoramic vista of snow-capped peaks and the unique Himalayan subculture. It's a journey that combines the beauty of nature with the richness of local culture, offering an unforgettable experience.",

    OverviewSubHeading: "Overview",
    OverviewDescription1: `One of the most exciting and impressive treks is the Ghorepani Poon Hill Trek. The evergreen trekking route leads you through beautiful historic ethnic villages and world-class mountain scenery. Poon Hill's gentle trekking fulfills your dream of seeing snow-capped peaks and marveling at the Himalayan subculture that offers a once-in-a-lifetime experience. It is a magnificent retreat that combines the incredible beauty of nature with the flavor of the unique local culture, making your trip so healthy. From Kyumi, the road follows Modi Khola and leads to Ghandruk, which is also connected to Nayapul.
    Ghandruk is a large and beautiful village with stunning views of Annapurna's southern summit towards Tadapani and then west to Ghorepani. The path preserves mosaic valleys, dense mosses, and icy waterfalls. It also has beautiful mountain villages, brilliant rhododendron forests, and a diverse range of ethnic groups and cultures. This excellent all-around component elevates the trekking experience in Nepal.
    `,
    OverViewDescription2: `The warmth of the region's inhabitants, combined with the beautiful landscapes that can be seen from Poon Hill, a small colorful village that also serves as a point of view window located in the Annapurna Conservation Area at an elevation of 3,210 m; it's more than you bargained for. The breathtaking view of the top of the fishtail [Machhapuchre] and the Modikhola River is breathtaking. There are marked hiking trails nearby, impressive mountains to see, fish to catch, and beautiful rare birds to see; this is what you live on this trip. The beautiful rhododendrons, sunrises, and sunsets are also a welcome addition to this trip. It's fantastic wherever you go. Ghorepani Poon Hill Trek is time-appropriate, and you can enjoy this wonderful trekking trip in Nepal.`,

    listofHighlights: [
      "Best Sunrise and Himalayas View from Poonhill (3210m)",
      "Exploring ethnic cultures of Annapurna region (Gurung, Thakali, Magars)",
      "Visit to Ghandruk Gurung village and Ulleri Magar Village",
      "Hiking through the beautiful Rhododendrons forest",
      "Cultural heritage sites visit in Kathmandu city",
      "View of Dhaulagiri, Manaslu, Annapurna I, and other Himalayas",
      "Exploration of small villages like Birethati, Hile, Tikhedhunga, Ghorepani, Tadapani",
      "Exploring the paradise of Pokhara valley",
      "Opportunity to see waterfalls and rice terraces",
      "Adventurous tea house and easy trek, popular among beginners",
    ],
    itinerary: [
      { day: "Arrival in Kathmandu" },
      { day: "Kathmandu: Sightseeing and Trek Preparation" },
      { day: "Drive from Kathmandu to Pokhara" },
      { day: "Pokhara Trek to Tikhedhunga" },
      { day: "Tikhedhunga to Ghorepani" },
      { day: "Ghorepani to Poon Hill and Trek to Tadapani" },
      {
        day: "Tadapani Trek to Ghandruk, Trekking to Nayapul and Drive to Pokhara",
      },
      { day: "Drive from Pokhara to Kathmandu" },
      { day: "Final departure" },
    ],

    priceIncludes: [
      "All arrival and departure transfer in private vehicle",
      "Hotels will be of tourist standard and during trekking will be local tea house/guests house",
      "All meals (lunch and dinner) as described in itinerary",
      "A private vehicle as per group size",
      "An English-speaking guide throughout the tour Trekking",
      "TIMS and permit",
      "2 guests = 01 Porter",
      "Tea House Trekking package (Room + Breakfast + Lunch + Dinner)",
    ],
    priceExcludes: [
      "Any kind of medical and personal insurance",
      "Any kind of personal nature items like bar and Laundry bills",
      "Evacuation in case of emergency",
      "Domestic flights",
      "Tips to the guide and driver",
      "Entrance Fees",
      "ANY ITEMS NOT MENTIONED ABOVE",
    ],
    usefulInformation: [
      "The best months to visit Poon Hill are April to May and September to early December",
      "This trek allows you to explore Pokhara's northwestern acreage",
      "The Ghorepani Poon Hill hike is moderate and easy, ideal for family outings",
      "The main attraction is reaching the summit of Poon Hill at sunrise and seeing panoramic views of the famous Annapurna region, including Annapurna South, Annapurna I, Annapurna II, III, and IV, Dhaulagiri, Lamjung Himal, Gangapurna, Machhapuchhare, and Manaslu",
    ],
  },

  {
    destination_id: "kathmandu_nagarkot_3_nights_4_days",
    price: "N/A",
    title: "Kathmandu  Nagarkot Tour 3 Nights 4 Days",
    duration: "4 days",
    activity: "Multiple Activities",
    included: "All inclusive",
    available: "Any",
    imageUrl: [
      {
        id: 1,
        url: "/assets/destination/nagarkot/nagarkot1.jpeg",
        alt: "Nagarkot",
      },

      {
        id: 3,
        url: "/assets/destination/nagarkot/nagarkot3.jpeg",
        alt: "Nagarkot",
      },
      {
        id: 4,
        url: "/assets/destination/nagarkot/nagarkot4.jpeg",
        alt: "Nagarkot",
      },
    ],

    description:
      "Explore the cultural heartland of Nepal with the Kathmandu – Nagarkot Tour. This tour combines visits to UNESCO World Heritage Sites in Kathmandu Valley with a scenic excursion to Nagarkot, offering breathtaking views of the Himalayas.",
    OverviewSubHeading: "Overview:",
    OverviewDescription1: `The Kathmandu valley, which covers an area of 257 square miles, is Nepal's cultural heartland. Newars still have their age-old mystic festivals on the grounds of historic palaces and temples in the backstreets of the bustling metropolis. Kathmandu contains around 130 nationally recognized monuments, organized into seven groupings, making it a UNESCO World Heritage Site. 
   A Kathmandu tour includes cultural attractions, Himalayan vistas, and hiking or a short trip. The surrounding green hills provide a backdrop for Himalayan sightseeing and a short and scenic cultural trek.
   `,
    OverViewDescription2: `Nagarkot tour is 32 kilometers east of Kathmandu valley, on a hilltop at an elevation of 2175 meters above sea level. It is one of the most beautiful scenic sites in Nepal's countryside. The excursion to Nagarkot, the valley's second highest peak, is known for its sunrise and sunset views of the Himalayas. Highlights for 2022 and 2023 are us. Nagarkot is bordered by densely forested slopes of pine trees and gives beautiful views of the Langtang ranges, Dorje Lakpa, Manaslu range, Ganesh Himal, and Gaurishankar. This is a beautiful getaway into nature, away from the bustling and concrete jungle of the capital city, where only the wind and the rustling sound of leaves disturb you.
   From Nagarkot, one can enjoy a beautiful view of the Indravati River valley in the east and the Kathmandu valley in the west. From the tower, the Nagarkot excursion provides the greatest view of the Himalayas. 
   `,
    listofHighlights: [
      "Exploration of Kathmandu's cultural attractions, Himalayan vistas, and scenic trekking",
      "Visiting UNESCO World Heritage Sites like Pashupati Nath Temple, Bouddhanath Stupa, Swaymbhu, and Patan Durbar Square",
      "Excursion to Nagarkot for stunning sunrise and sunset views of the Himalayas",
      "Exploring Bhaktapur Durbar Square, a UNESCO World Heritage Site, known for its ancient royal palace and temples",
    ],

    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival at Kathmandu airport, transfer to hotel",
      },
      {
        day: "Day 2",
        activity:
          "Full Day Kathmandu Valley Sightseeing Including Swayambhunath Stupa, Patan Durbar Square, Pasupatinath Temple and Bouddhanath Stupa",
      },
      {
        day: "Day 3",
        activity: "Drive to Nagarkot via Bhaktapur",
      },
      {
        day: "Day 4",
        activity: "Drive Back to Kathmandu airport for next destination",
      },
    ],

    priceIncludes: [
      "All ground transportation during the trip",
      "English-speaking tour guide",
      "Monuments entrance fee",
      "2 Nights hotel in Kathmandu on MAP Basis (Taleju Boutique Hotel or similar)",
      "1 Night hotel in Nagarkot on MAP Basis (Hotel View Point or similar)",
    ],
    priceExcludes: [
      "All personal nature expenses",
      "Other costs not mentioned in 'cost including' field",
      "Extra nights in Kathmandu and Nagarkot",
    ],

    usefulInformation: [
      "Kathmandu is the 17th highest capital in the world standing at an elevation of 1400m above sea level",
      "Best time to visit Kathmandu valley is from September to November for dry weather, clear skies, and cultural events",
      "Kathmandu is the center of Nepal's history, art, culture, and economy, with over 300 temples, monasteries, and monuments to explore",
      "The original inhabitants of Kathmandu are Newars, known for their unique culture and lifestyle",
      "Newari khaja, particularly samaybaji, is a signature dish of Newar culture, consisting of various delicious items served in a leaf bowl",
      "Nagarkot offers outstanding views of the Himalayas, breathtaking mountain scenery, and is famous for its sunrise and sunset views",
      "In ancient times, Nagarkot was a fort of the Kathmandu valley, built to monitor the activities of neighboring kingdoms",
    ],
  },

  {
    destination_id: "8_days_nepal_tour",
    title: "8 Days Nepal Tour",
    price: "£400",
    description:
      "Nepal is a very beautiful country with a fascinating history. Nepal is a country has it everything, whether it's sacred temples, historical sites, or scenic mountains. Nepal, as one of the most popular destinations for travelers from all over the world, awaits your visit. The 7 Nights 8 Days Nepal Tour is a fantastic way to see Nepal's four most gorgeous cities: Kathmandu, Pokhara and Jomsom.",
    duration: "8 days",
    available: "Multiple Activities",
    included: "Multiple Activities",
    imageUrl: [
      {
        id: 2,
        url: "/assets/destination/nepal/nepal2.jpeg",
        alt: "8 Days Nepal Tour",
      },

      {
        id: 1,
        url: "/assets/destination/nepal/nepal1.webp",
        alt: "8 Days Nepal Tour",
      },
      {
        id: 3,
        url: "/assets/destination/nepal/nepal3.jpeg",
        alt: "8 Days Nepal Tour",
      },
      {
        id: 4,
        url: "/assets/destination/nepal/nepal4.jpeg",
        alt: "8 Days Nepal Tour",
      },
      {
        id: 5,
        url: "/assets/destination/nepal/nepal5.jpeg",
        alt: "8 Days Nepal Tour",
      },
      {
        id: 6,
        url: "/assets/destination/nepal/nepal6.jpeg",
        alt: "8 Days Nepal Tour",
      },
      {
        id: 7,
        url: "/assets/destination/nepal/nepal7.jpeg",
        alt: "8 Days Nepal Tour",
      },
      {
        id: 8,
        url: "/assets/destination/nepal/nepal8.jpeg",
        alt: "8 Days Nepal Tour",
      },
      {
        id: 9,
        url: "/assets/destination/nepal/nepal9.jpeg",
        alt: "8 Days Nepal Tour",
      },
    ],
    OverviewSubHeading: "Experience the Best of Nepal in 8 Days",
    OverviewDescription1:
      "The 7 Nights 8 Days Nepal Tour is one of the most popular Nepal local tour packages from Kathmandu, offering a mix of natural beauty, cultural significance, and wildlife. From exploring the vibrant city of Kathmandu to experiencing the serene beauty of Pokhara and the adventurous spirit of Jomsom, this tour promises an unforgettable journey through the heart of Nepal.",
    OverViewDescription2:
      "The tour includes visits to UNESCO World Heritage Sites, scenic flights, sightseeing tours, and cultural experiences, providing a comprehensive overview of Nepal's diverse attractions.",
    listofHighlights: [
      "Visit Kathmandu, Pokhara, and Jomsom - Nepal's most gorgeous cities",
      "Explore UNESCO World Heritage Sites in Kathmandu",
      "Experience a scenic flight to Jomsom with views of the Annapurna and Dhaulagiri peaks",
      "Discover the cultural heritage of Nepal through sightseeing tours and cultural experiences",
      "Enjoy outdoor adventures like paragliding and boating in Pokhara",
      "Witness breathtaking sunrise views over the Himalayas from Nagarkot",
      "Immerse yourself in the natural beauty and tranquility of Nepal's landscapes",
      "Experience the warmth and hospitality of Nepalese people throughout the journey",
    ],
    itinerary: [
      {
        day: "Day 1",
        activity: "Arrival and transfer to Hotel",
        activitydetails:
          "Upon arrival at Kathmandu International Airport, a Go Nepal representative will meet and transfer you to the hotel. Rest of the day at leisure.",
      },
      {
        day: "Day 2",
        activity: "Drive from Kathmandu to Pokhara",
      },
      {
        day: "Day 3",
        activity: "Fly to Jomsom, Sightseeing",
      },
      {
        day: "Day 4",
        activity: "Fly back to Pokhara, Explore Pokhara",
      },
      {
        day: "Day 5",
        activity: "Paragliding, Drive to Kathmandu",
      },
      {
        day: "Day 6",
        activity: "Kathmandu City Tour, Drive to Nagarkot",
      },
      {
        day: "Day 7",
        activity: "Sunrise, back to Kathmandu via Bhaktapur",
      },
      {
        day: "Day 8",
        activity: "Departure to Airport",
      },
    ],
    priceIncludes: [
      "All ground transportation by private vehicle as per itinerary",
      "Domestic flight ticket Pokhara – Jomsom – Pokhara",
      "Hotel accommodation in Kathmandu, Pokhara, and Jomsom",
      "Annapurna Conservation Permit",
    ],
    priceExcludes: [
      "Personal Nature expenses",
      "Monuments entrance fee in Kathmandu and Pokhara",
      "All sorts of drinks",
      "Extra nights in Kathmandu, Pokhara, Jomsom, and Nagarkot",
      "Tips for Guide and Driver",
      "Other expenses not mentioned in 'Includes' section",
    ],
    usefulInformation: [
      "Kathmandu is the 17th highest capital in the world, standing at an elevation of 1400m above sea level",
      "Best time to visit Kathmandu valley is from September to November for dry weather and clear skies",
      "Kathmandu is the center of Nepal's history, art, culture, and economy, with over 300 temples, monasteries, and monuments to explore",
      "Nagarkot offers outstanding views of the Himalayas and is famous for its sunrise and sunset views",
      "Bhaktapur Durbar Square is a UNESCO World Heritage Site, known for its stunning architecture and cultural significance",
    ],
  },
];
